var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogAndCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4233 3650",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 19349.7,18758 c 0,0 3191.7,-5344.9 -3197.3,-7489.4 0,0 -2898.9,-3850.1 -5650.5,-1576.4 -2308.81,1907.8 -781.05,5728.6 1342.7,6809.9 690.3,351.4 1147.1,1036.9 1185.2,1810.5 v 0.1 l 6319.9,445.3",
    id: "path42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 16152.4,25669.2 c 0,0 1121.9,42.6 1768.1,-703 0,0 1782.3,196.8 1782.3,-3685.4 0,0 2783.5,-4345.7 -3507.8,-4345.7 h -26.6 c -6291.41,0 -3507.9,4345.7 -3507.9,4345.7 0,3882.2 1782.3,3685.4 1782.3,3685.4 646.2,745.6 1768.2,703 1768.2,703 h -58.6",
    id: "path88"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.333333, 0, 0, -1.333333, -536.405518, 4500.134766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.1, 0, 0, 0.1, -0.000364, 0.001016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 32705.6,19175 c 0,7110.7 -5764.3,12875 -12875,12875 -7110.6,0 -12874.99,-5764.3 -12874.99,-12875 0,-4331.3 2138.77,-8162.9 5417.79,-10496.7 h 14914.5 c 3278.9,2333.8 5417.7,6165.4 5417.7,10496.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      paintOrder: "fill",
      fill: "rgba(251, 254, 255, 0.3)"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7592.68,13207.1 c 122.73,-651 581.76,-1858.3 2298.51,-1858.3 v -1259 c 0,0 -3421.82,99.3 -2484.23,3127 29.45,95.1 167.28,88.1 185.72,-9.7",
    style: {
      fill: "#d3670d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8281.49,10744.5 c -209.13,128 -401.66,291.1 -549.65,498.4 -292.05,409.2 -370.52,939.1 -234.62,1578.7 26.07,-81.4 57.56,-167.2 95.5,-255.3 -106.06,-886.3 227.25,-1456.1 688.77,-1821.8",
    style: {
      fill: "#e9b386",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9392.78,10340.5 c -129.46,24.4 -275.63,58.2 -428.27,104.7 -274.79,267.6 -481.07,625.3 -535.94,1103.1 200.89,-130.6 439.77,-237.3 724.03,-305.4 l 19.57,-134.5 c 41.38,-222.7 98.97,-442.9 176.78,-657 13.98,-37.2 28.59,-74.2 43.83,-110.9",
    style: {
      fill: "#93482b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7408.16,13172.4 v -0.1 0.1 m 89.06,-350.8 c -135.9,-639.6 -57.43,-1169.5 234.62,-1578.7 508.54,-712.6 1542.43,-901 1971.63,-949.3 v 872.2 c -1448,74.3 -1998.39,1007.3 -2206.25,1655.8 m 2394,-2919.5 c -1.82,0 -3.62,0 -5.43,0.1 -69.1,2 -1700.68,61.2 -2458.55,1121.1 -414.89,580.3 -482.03,1336.9 -199.61,2249 38.67,124.9 157.38,206.9 287.65,199.4 132.18,-7.6 237.4,-99.9 261.92,-229.8 120.06,-636.9 554.44,-1705.4 2114.02,-1705.4 103.71,0 187.78,-84 187.78,-187.7 v -1259 c 0,-50.7 -20.6,-99.3 -57,-134.6 -35.03,-34.1 -82.01,-53.1 -130.78,-53.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19575.4,10088.3 c -19,1568.6 148.8,3918.1 148.8,3918.1 l -2944.1,-1397.7 c 0,-1859.2 1032,-3917.5 1032,-3917.5 h 1853.8 489.4 c 65.2,130.9 101.4,273.5 101.4,423 0,412.3 -272.7,773.5 -681.3,974.1",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19626.3,8879 h -1329.7 c 15.6,70.9 24.3,143.5 25.4,216.3 1.8,167.2 -33,336.4 -103.6,486.1 -68.6,151.2 -169.2,283.1 -285,394.2 -89.3,84.9 -188.4,156.9 -293.1,217.5 -0.9,245.8 4.1,491.9 14.9,738.1 11.8,262.6 21.6,525.3 25.8,788.5 679.5,368.9 1231.1,804 1652.1,1303.2 -193.1,-867.9 -430.2,-2132.6 -418.8,-3068.5 408.5,-200.5 744.9,-419.1 744.9,-831.4 0,-83.8 -11.4,-165.4 -32.9,-244",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17930.5,8879 h 2099.9 c 25.6,76.7 38.5,155.5 38.5,235.2 0,327.3 -215.4,628.4 -576.2,805.5 -63.6,31.2 -104.2,95.5 -105.1,166.3 -14.7,1215.6 83.3,2914 128,3613.5 l -2546.4,-1208.8 c 36.5,-1528.2 763.1,-3186.6 961.3,-3611.7 m 2224.8,-375.5 h -2343.2 c -71,0 -136,40.1 -167.8,103.6 -43,85.6 -1052,2119.6 -1052,4001.6 0,72.5 41.8,138.5 107.3,169.6 l 2944.1,1397.7 c 60.2,28.6 131.3,23.1 186.4,-14.6 55.1,-37.7 86.1,-101.8 81.3,-168.4 -1.6,-22.9 -159.3,-2250.6 -149.3,-3791.7 429.5,-248.3 682.3,-647.7 682.3,-1087.1 0,-174.8 -40.7,-345.3 -121,-506.6 -31.7,-63.8 -96.8,-104.1 -168.1,-104.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14683.6,18394.3 c 0,0 -669.8,-27.5 -1543.2,-281.7 -101.4,-736.8 -562.8,-1377.4 -1233.9,-1719.1 -2065.84,-1051.8 -3598.07,-4555.1 -1929.27,-6679.7 145.17,-184.8 314.17,-359.3 509.57,-520.7 140.5,-116.1 281.3,-216.7 422.1,-303.8 -228.1,325.2 -400.9,708.2 -420.1,1048.9 -21.7,383.8 151.4,713.8 659.8,846.7 1552.4,405.6 296.2,2894.6 755.3,4160.2 459.1,1265.5 1327.6,1278 2320.2,1484 992.6,206 459.5,1965.2 459.5,1965.2",
    style: {
      fill: "#452735",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13162.9,18093.1 c -106.7,-735.9 -571.2,-1378.8 -1245,-1721.9 -1173.9,-597.6 -2183.58,-2001.5 -2512.53,-3493.4 -265.96,-1206.2 -55.86,-2324.4 591.55,-3148.6 146.78,-186.9 316.98,-360.8 505.78,-516.9 103.5,-85.4 210,-164.7 318,-236.6 -214.6,332.6 -340.5,670.3 -356.9,961.1 -17.7,312.4 85.8,717.4 678.5,872.3 941.6,246 828.3,1264.2 708.2,2342.1 -72,647 -146.5,1316.1 29.9,1802.4 411.8,1135.4 1150.8,1274.3 2006.4,1435.3 108.8,20.4 219.7,41.3 332.2,64.6 191,39.7 337,142.6 434.1,306.1 303.1,510 53,1463.1 12,1608.7 -115.7,-6.9 -731.3,-52.7 -1502.2,-275.2 m -2163.7,-9289 -103.4,63.9 c -144.5,89.3 -287.5,192.2 -424.9,305.8 -191.6,158.3 -364.3,334.8 -513.33,524.5 -656.79,836.2 -870.26,1969.2 -601.03,3190.2 332.03,1505.8 1352.16,2923.2 2538.66,3527.3 664.2,338.2 1120.5,973.8 1220.5,1700.2 l 2.2,16.1 15.5,4.5 c 866.3,252.1 1542.5,282.4 1549.2,282.7 l 19.3,0.8 5.7,-18.5 c 13.5,-44.6 326.8,-1098.1 -11.5,-1667.5 -104.5,-176 -261.6,-286.9 -467,-329.5 -112.7,-23.4 -223.9,-44.3 -333.1,-64.9 -840.5,-158.1 -1566.5,-294.6 -1968.6,-1403.1 -172.4,-475.4 -98.6,-1138.5 -27.2,-1779.9 117.1,-1051.6 238.2,-2139 -745.3,-2396 -443.3,-115.9 -665,-399.8 -641.2,-821.1 17.4,-306.4 168.8,-684 415.7,-1035.9 l 69.8,-99.6",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19349.7,18758 c 0,0 3191.7,-5344.9 -3197.3,-7489.4 0,0 -2898.9,-3850.1 -5650.5,-1576.4 -2308.81,1907.8 -781.05,5728.6 1342.7,6809.9 690.3,351.4 1147.1,1036.9 1185.2,1810.5 v 0.1 l 6319.9,445.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40",
    clipPath: "url(#clipPath44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15982.2,19381.6 c 0,0 -951,-1159.8 1096.9,-2563.8 2047.9,-1404 1446.3,-3339.4 515,-3533.4 0,0 54.4,1095.2 -1995.2,1287.7 -2049.6,192.4 -393.1,-4674.1 -393.1,-4674.1 l -503.2,-34.7 c 0,0 -330.9,273.2 -785.1,334.2 0,0 922.8,1171.9 -751.5,1390.9 -1674.3,219.1 -1893.7,-1170.8 -3454.08,-1485 -1560.37,-314.2 -3074.42,4204.4 -416.43,7303.8 2658.01,3099.3 6686.71,1974.4 6686.71,1974.4",
    style: {
      fill: "#d3670d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 11929.8,16334.8 c -1090.4,-555.2 -2041.7,-1913 -2313.26,-3302 l -0.4,-1.4 -0.27,-2.3 c -182.33,-841.7 -178.25,-1587.1 10.28,-2229.5 74.07,243.8 292.98,410.6 794.05,389.9 1725.3,-71.4 719.7,2386 751,3481.1 31.3,1095.3 1173.4,891.9 1658.4,1392.5 273.5,282.3 151.7,727.8 -6.6,1063 -221.4,-329 -526.1,-604.4 -893.2,-791.3",
    style: {
      fill: "#93411d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9559.7,12739.5 c 15.84,94.2 33.97,188.1 54.21,281.7 0.75,2.9 1.44,5.8 2.06,8.7 l -0.1,-0.8 c -21.19,-97.9 -39.85,-194.3 -56.01,-289.5 -0.05,-0.1 -0.1,-0.1 -0.16,-0.1 m 1030.7,2427 c 385.3,505.3 848.2,918.2 1339.3,1168.3 1.3,0.6 2.6,1.3 3.9,1.9 0.1,0.1 0.3,0.2 0.4,0.2 1.2,0.6 2.4,1.3 3.6,1.9 0.2,0.1 0.4,0.2 0.6,0.3 1.2,0.6 2.3,1.2 3.5,1.8 0.2,0.1 0.5,0.2 0.7,0.3 1.1,0.6 2.3,1.2 3.4,1.8 0.2,0.1 0.5,0.3 0.8,0.4 1.1,0.6 2.2,1.2 3.4,1.8 0.2,0.1 0.5,0.2 0.7,0.3 1.1,0.6 2.2,1.2 3.4,1.8 0.2,0.2 0.5,0.3 0.7,0.4 1.1,0.6 2.3,1.2 3.4,1.8 0.2,0.1 0.4,0.2 0.6,0.3 1.1,0.6 2.2,1.2 3.3,1.7 0.1,0.1 0.4,0.3 0.6,0.4 1.1,0.6 2.3,1.2 3.4,1.8 0.3,0.1 0.5,0.2 0.7,0.4 1.2,0.6 2.2,1.1 3.3,1.7 0.3,0.2 0.6,0.3 0.9,0.5 1.1,0.6 2.2,1.1 3.3,1.7 0.2,0.2 0.6,0.4 0.8,0.5 1.1,0.6 2.1,1.1 3.2,1.7 0.4,0.2 0.7,0.4 1,0.6 1.1,0.5 2.1,1.1 3.2,1.7 0.3,0.1 0.6,0.3 0.9,0.4 1,0.6 2.1,1.2 3.1,1.7 0.4,0.2 0.7,0.4 1,0.6 1,0.5 1.9,1 2.9,1.5 0,0.1 0,0.1 0.1,0.1 -20.1,-10.9 -40.3,-21.6 -60.7,-32 -491.2,-250.1 -954.1,-663 -1339.4,-1168.3 m 1403.2,1202 c 0,0 0.1,0.1 0.2,0.1 -0.1,0 -0.2,-0.1 -0.2,-0.1 m 924.4,524.2 c -27.3,80.8 -60.1,159.3 -94.6,232.6 56.5,83.9 107.5,171.4 152.7,261.8 52.1,-30.6 106,-60.2 161.7,-88.6 -58.5,-143 -132.3,-279 -219.8,-405.8",
    style: {
      fill: "#e9b386",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9559.86,12739.6 c 16.16,95.2 34.82,191.6 56.01,289.5 l 0.1,0.8 c 0.2,1 0.4,1.9 0.58,2.9 149.25,763.3 503.75,1517.3 973.85,2133.7 385.3,505.3 848.2,918.2 1339.4,1168.3 20.4,10.4 40.6,21.1 60.7,32 0.3,0.1 0.6,0.3 0.9,0.5 0.7,0.4 1.4,0.8 2.2,1.2 0,0 0.1,0.1 0.2,0.1 0.2,0.1 0.3,0.2 0.5,0.3 0.3,0.1 0.6,0.3 0.9,0.5 1.1,0.6 2.2,1.2 3.3,1.8 0.2,0.1 0.5,0.3 0.8,0.4 1,0.6 2.1,1.2 3.2,1.8 0.3,0.2 0.6,0.3 1,0.5 1,0.6 2,1.2 3,1.7 0.4,0.2 0.7,0.4 1,0.6 1.1,0.6 2.1,1.1 3.1,1.7 0.3,0.2 0.7,0.4 1,0.6 1.1,0.6 2.1,1.1 3.2,1.7 0.2,0.2 0.5,0.3 0.8,0.5 0.9,0.5 2,1.1 3,1.7 0.3,0.2 0.6,0.3 1,0.6 0.9,0.5 1.9,1 2.9,1.6 0.3,0.1 0.5,0.3 0.8,0.4 1.1,0.7 2,1.2 3.1,1.8 0.3,0.2 0.6,0.4 1,0.6 1,0.5 2.1,1.1 3.1,1.7 0.3,0.2 0.6,0.4 0.9,0.6 1.1,0.6 2.1,1.2 3.2,1.8 0.3,0.1 0.6,0.3 0.8,0.5 1.1,0.6 2.2,1.2 3.2,1.8 0.3,0.2 0.6,0.3 0.9,0.5 1,0.6 2.1,1.2 3.2,1.8 0.2,0.2 0.5,0.4 0.8,0.5 1,0.6 2.2,1.3 3.3,1.9 0.2,0.1 0.3,0.2 0.4,0.3 1.1,0.6 2.3,1.3 3.4,2 0.1,0 0.2,0.1 0.4,0.2 1.1,0.6 2.3,1.3 3.4,2 0.2,0.1 0.4,0.2 0.6,0.3 1.1,0.7 2.2,1.3 3.3,1.9 0.2,0.2 0.5,0.4 0.8,0.5 1.1,0.7 2.1,1.3 3.2,1.9 0.2,0.2 0.5,0.3 0.8,0.5 1.1,0.6 2.2,1.3 3.3,1.9 0.2,0.2 0.4,0.3 0.6,0.4 1.1,0.7 2.2,1.4 3.4,2 0.2,0.2 0.3,0.2 0.5,0.3 1.2,0.7 2.3,1.4 3.5,2.1 0.1,0.1 0.3,0.2 0.4,0.3 2.5,1.5 4.9,2.9 7.4,4.4 0.1,0.1 0.2,0.1 0.2,0.2 1.2,0.7 2.4,1.4 3.6,2.1 0.1,0.1 0.3,0.2 0.5,0.3 1.1,0.7 2.2,1.4 3.3,2.1 0.2,0.1 0.5,0.2 0.7,0.3 1.1,0.7 2.2,1.4 3.4,2.1 0.1,0.1 0.3,0.2 0.4,0.3 1.2,0.7 2.3,1.4 3.5,2.1 0.2,0.1 0.3,0.2 0.4,0.3 1.3,0.8 2.4,1.5 3.6,2.2 l 0.1,0.1 c 3.8,2.4 7.7,4.8 11.5,7.1 0.1,0.1 0.1,0.1 0.2,0.1 1.2,0.8 2.4,1.6 3.7,2.4 0,0 0.1,0 0.1,0.1 1.2,0.7 2.5,1.5 3.7,2.3 0,0 0.2,0.1 0.3,0.2 1.2,0.7 2.5,1.5 3.7,2.3 v 0 c 1.3,0.8 2.6,1.7 3.8,2.4 l 0.1,0.1 c 279,177.7 514.4,409.3 694.4,676.7 34.5,-73.3 67.3,-151.8 94.6,-232.6 -203.1,-294.4 -480.1,-539.2 -810.5,-707.4 -1138.1,-579.5 -2104.9,-1945.8 -2401.85,-3382.7 -49.84,-21.2 -98.46,-42.3 -145.79,-63",
    style: {
      fill: "#c9a08e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14369.8,9446.7 c -62,0 -122.7,30.7 -158.5,86.8 -55.8,87.4 -30.1,203.5 57.3,259.3 1019.9,650.5 1726.8,1579.5 1733.8,1588.8 22.8,30.2 54.3,52.9 90.2,65 1914.1,642.4 3132.8,1637.7 3622.4,2958 669,1804.7 -233.6,3707 -471.7,4157.6 l -6040.4,-425.6 c -94.2,-763.9 -570.6,-1444.2 -1273.2,-1801.8 -1090.3,-555.2 -2041.57,-1913 -2313.15,-3302 -19.92,-101.8 -118.6,-168.2 -220.31,-148.3 -101.75,19.9 -168.11,118.6 -148.25,220.3 296.94,1518.5 1306.21,2951 2511.41,3564.6 633.6,322.6 1048.6,955.8 1082.9,1652.5 4.6,94.9 79.5,171.4 174.3,178 l 6320,445.3 c 70.1,5.2 138,-30.2 174.3,-91 56.8,-95 1380.2,-2352.7 557.2,-4577.4 -525.6,-1420.6 -1804.7,-2486.3 -3802,-3167.9 -161.8,-204.9 -838.4,-1022.2 -1795.5,-1632.7 -31.3,-19.9 -66.3,-29.5 -100.8,-29.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14769.7,11679.9 c -4.3,4.6 -10.1,7.9 -16.8,8.8 -1.3,0.2 -2.6,0.3 -4,0.3 -4.4,0 -8.7,-1.1 -12.5,-3 -34.2,175.4 -65.3,355 -90.9,534.8 16.2,-0.3 32.1,-0.5 48.1,-0.5 898.5,0.2 1638.2,501.8 2064,1151.3 203.8,79.8 379.2,203.5 520,368.3 31.2,36.6 60.6,75 88.2,115.3 127.2,-156.5 183.7,-306.2 208.8,-413 -36.3,-139.8 -66.6,-280.2 -93.3,-421 l -2711.6,-1341.3 m 2913.5,472 c -0.7,155.5 -2.7,311.2 -5.2,467.1 -5.7,225.8 -12.5,452 -28.1,679.2 764.6,219.5 1267.6,1617.7 164.4,2877.3 126.3,225 229.5,476.6 304.5,747.5 640.8,136.4 1155,352.1 1540.4,646.2 270.9,-828.3 481.5,-2016.2 55.8,-3164.6 -336.5,-907.5 -1017.4,-1661.3 -2031.8,-2252.7",
    style: {
      fill: "#b2b2d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14712.8,10106.2 c -140.1,103.5 -299,166.4 -454.6,204.2 -41.6,9.6 -83.1,17.7 -124.5,24.3 60.9,143.2 110.1,293.5 142.8,451.5 26.6,118.4 39.9,242.8 40.1,369.1 -3.2,126.7 -27.5,255.5 -75.2,376 -47.1,120.8 -119.6,230.3 -202.9,324.4 -84.1,94 -182.4,170.6 -285.5,232.1 -103.7,61 -212.9,106.7 -324.1,139.4 -111.5,31.3 -224.9,52.9 -338.8,53.3 10.2,-5.2 20.3,-10.4 30.4,-15.7 -54.3,10 -106.8,14.7 -158,14.7 -675.1,0 -1110.1,-819.4 -2097.4,-1037.7 670.4,222.5 619.7,1100.2 488.9,1971 20.6,0.4 41.3,0.7 62,0.7 531,0 1116.3,-135.5 1742.8,-520.6 522.6,-321.3 1024.9,-463 1486.7,-472.1 25.6,-179.8 56.7,-359.4 90.9,-534.8 -7.9,-4 -13.8,-11.6 -15.2,-21.1 -19.3,-135.6 -28.4,-272.1 -20.7,-405.6 3.5,-66.9 7.8,-134 14.7,-200.5 8.2,-66.2 18.3,-132.1 29.5,-197.8 21.1,-131.8 56.8,-259.9 89.1,-388.9 20.1,-73.4 40.1,-146.9 60.9,-220.2 -58.9,-48.8 -119.5,-97.5 -181.9,-145.7 m -4313.2,1083.1 c -20.6,0 -40.8,0.6 -60.6,1.9 26.2,0 53.3,-0.6 81.2,-1.7 v 0 0 c -6.9,-0.2 -13.8,-0.2 -20.6,-0.2 m 7250.3,2108.9 c -3.9,57.1 -8.3,114.3 -13.4,171.5 -1,11.1 -8.8,21.1 -20.1,24.1 -2.4,0.6 -4.7,0.9 -7,0.9 -12.1,0 -23.1,-8 -26.3,-20.2 -2.9,-10.8 -5.7,-21.5 -8.5,-32.3 -25.1,106.8 -81.6,256.5 -208.8,413 291.1,425.4 379.5,1057.9 255.5,1841.7 -7.8,49.2 -16.4,97.5 -25.8,145 78.9,103.1 152.1,214.6 218.8,333.6 1103.2,-1259.6 600.2,-2657.8 -164.4,-2877.3 m -3357.5,3387.5 c -244.5,125 -442.2,255.2 -602,385.2 164.4,-54 339.8,-101.3 525.8,-141.9 22.8,-83 48.3,-164.1 76.2,-243.3",
    style: {
      fill: "#93482b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10420.2,11189.5 v 0 c -27.9,1.1 -55,1.7 -81.2,1.7 -371.44,24.3 -593.13,272.2 -724.67,580.3 -12.23,341.2 20.45,688.2 91.32,1031.1 454.15,193.6 1011.15,397.7 1648.35,410.2 130.8,-870.8 181.5,-1748.5 -488.9,-1971 -137,-30.3 -284.6,-49 -444.9,-52.3",
    style: {
      fill: "#672d37",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9546.87,12659.8 c 4.09,26.6 8.37,53.2 12.83,79.7 0.06,0 0.11,0 0.16,0.1 -4.52,-26.7 -8.86,-53.3 -12.99,-79.8",
    style: {
      fill: "#a37d80",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9614.33,11771.5 c -54.05,126.6 -92.84,263.3 -120.59,398.9 10.01,163.3 28.06,326.7 53.13,489.4 4.13,26.5 8.47,53.1 12.99,79.8 47.33,20.7 95.95,41.8 145.79,63 -70.87,-342.9 -103.55,-689.9 -91.32,-1031.1",
    style: {
      fill: "#8c7086",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14909.3,9914.6 c -51.5,65.7 -110.7,125.5 -176.1,176.1 -6.8,5.3 -13.6,10.4 -20.4,15.5 62.4,48.2 123,96.9 181.9,145.7 15.4,-54.6 31.3,-109 48.1,-163.1 11.8,-37.4 23.7,-74.7 35.7,-112 -22.9,-20.8 -45.8,-41.4 -69.2,-62.2 m 2773.9,2021 c 0.3,72.1 0.3,144.2 0,216.3 1014.4,591.4 1695.3,1345.2 2031.8,2252.7 425.7,1148.4 215.1,2336.3 -55.8,3164.6 54.9,41.9 107.2,85.4 156.9,130.5 495.6,-1456.6 847.2,-4088.7 -2132.9,-5764.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13853,10199.4 c 153.2,371.8 228.8,825.7 256.6,1025.9 7.7,33.9 12,68.3 13.1,103 v 0.3 0 c 7.1,228 -133.4,472.2 -511.6,722 -1243,820.8 -1547.7,-826.8 -3190.9,-861.1 -1124.71,-23.5 -987.82,1879.3 -987.82,1879.3 C 8682.45,9607.2 11258.1,8691.2 11258.1,8691.2 h 3660.5 c 203.6,1134.1 -401.6,1464.2 -1065.6,1508.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9432.47,12881 c -11.96,0 -24.07,1.2 -36.23,3.5 -101.75,19.9 -168.11,118.6 -148.25,220.3 296.94,1518.5 1306.21,2951 2511.41,3564.6 633.6,322.6 1048.6,955.8 1082.9,1652.5 5.1,103.5 93.5,183.6 196.7,178.3 103.6,-5.1 183.4,-93.2 178.3,-196.8 -40.9,-830.8 -534.2,-1585.1 -1287.6,-1968.6 -1090.3,-555.2 -2041.57,-1913 -2313.15,-3302 -17.53,-89.6 -96.09,-151.8 -184.08,-151.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12413,10049.5 c 284,124.3 578.9,211 886.6,266 307.1,50.1 629.1,71 958.6,-5.1 163.2,-39.7 330,-106.9 475,-219.7 144.7,-112 259.5,-268.8 325.4,-436.3 19.8,-41.5 31,-84.1 42.9,-126.8 11.8,-42.7 25.2,-85.5 30,-128.1 l 19.6,-128.1 5.2,-126.4 2.2,-63.2 -3.3,-61.7 -7.1,-123.4 c -8.1,-81.2 -22.2,-160.5 -33.4,-240.7 -13.4,-95.8 -95.9,-165 -190.2,-164.1 l -5.9,0.1 -915.1,7.9 -915.1,3.8 h -1830.3 -2.8 c -20.9,0 -41.5,4 -60,10.9 -34.9,13 -59.4,23.4 -87.4,35.7 -27.1,11.8 -53.5,24.2 -79.6,36.8 -52.2,25.3 -103.1,52.1 -153.2,80 -100,56.2 -196.6,117.2 -290.1,182.6 -186.4,131.5 -359.7,281.3 -516.9,446.7 -315.34,330.7 -558.82,728.6 -719.15,1155 -77.81,214.1 -135.4,434.3 -176.78,657 l -24.39,167.7 -11.84,83.9 -7.06,84.2 -13.89,168.4 -4.42,168.4 c -8.72,449.2 44.49,894.7 138.57,1327.5 l 0.05,0.3 c 22,101.2 121.88,165.4 223.08,143.4 101.16,-22 165.37,-121.9 143.38,-223.1 h -0.03 c -89.2,-410.1 -138.23,-827.3 -130.13,-1241.1 l 3.94,-155 12.84,-154 6.3,-77 10.91,-76.3 22.02,-152.5 c 37.7,-201.5 89.53,-399.6 158.97,-591.2 143.62,-380.9 359.03,-733.1 639.63,-1027.4 139.9,-147.2 294.4,-280.9 460.5,-398.1 83.3,-58.2 169.3,-112.5 257.3,-162 44.1,-24.5 88.7,-48.1 133.6,-69.7 22.4,-10.9 44.9,-21.4 67.2,-31.2 21.3,-9.5 46.6,-19.8 62.2,-25.7 l -62.8,10.8 h 1830.3 l 915.1,3.9 915.1,7.8 -196.1,-164 c 8.6,69.1 19.9,138.5 26.9,207 l 6,102.1 3.2,51 -2,49.7 -3.2,99.3 -13,95.4 c -2.3,32.7 -12,61.8 -19.6,91.9 -7.6,30 -14.1,60.8 -27.3,87.4 -41.3,113.4 -106,211.2 -196.7,287.9 -89.4,78 -204.1,136.1 -331,174.7 -254.8,78.4 -546.3,91.5 -835.9,76.7 -290.7,-14.5 -586.8,-59 -876.3,-118.2 l -2.9,-0.6 c -33.9,-6.9 -67,15 -74,48.9 -6,29.5 9.8,58.4 36.3,69.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14171.6,9568.2 c 59,-40.1 101.5,-104.2 134.1,-170.3 32.4,-67.1 55.3,-139.7 69.4,-213.3 15.7,-74 22.4,-148.9 26.5,-224.3 0.5,-37.3 1.7,-75.2 1.3,-112.9 l -4.6,-112.7 c -3.5,-85.8 -75.9,-152.5 -161.7,-149 -85.8,3.5 -152.5,75.9 -149,161.7 0.8,19.3 5,37.7 12.2,54.4 l 1.9,4.5 38.9,90.6 c 12,30.5 22.5,61.3 34.1,92.4 19.8,62.1 37.9,125.8 47.9,190.4 11.6,64.8 15.5,130.7 9.9,196.9 -6.4,65.6 -20.7,133.8 -60.9,191.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13449.6,9465.9 c 39.9,-48.6 74,-103.2 104,-160.6 30.1,-57.4 55.7,-118.4 75.6,-182.2 20.2,-63.8 35.9,-130.6 44,-199.5 10,-68.9 10.4,-139.5 7.8,-211.5 l -0.1,-1.4 c -3.1,-86 -75.4,-153.3 -161.5,-150.1 -86.1,3.1 -153.3,75.4 -150.1,161.5 0.7,21.8 6.3,43.1 15.1,61.6 23,48.1 45.7,98.9 60.4,152.9 16.5,53.8 26.9,110.4 32.9,168.6 6.4,58.3 7.1,118.3 2.7,178.8 -4.5,60.5 -13.5,121.7 -30.8,181.9",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13090.1,12280.5 c 113.9,-0.4 227.3,-22 338.8,-53.3 111.2,-32.7 220.4,-78.4 324.1,-139.4 103.1,-61.5 201.4,-138.1 285.5,-232.1 83.3,-94.1 155.8,-203.6 202.9,-324.4 47.7,-120.5 72,-249.3 75.2,-376 -0.2,-126.3 -13.5,-250.7 -40.1,-369.1 -49.3,-238.4 -136.3,-459.2 -244,-664.3 -43.4,-82.6 -145.6,-114.4 -228.2,-71 -80,42 -112.3,139.1 -74.9,220.2 l 0.9,2 c 88,190 165.6,383.8 198,580.1 18.4,98 19.7,195 17.5,289.4 -6.7,93.8 -19.3,184.5 -42.4,273.3 -42.9,177.9 -142.4,347.5 -287.9,492.3 -144.8,145.2 -324.6,270.1 -525.4,372.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.4,25669.2 c 0,0 1121.9,42.6 1768.1,-703 0,0 1782.3,196.8 1782.3,-3685.4 0,0 2783.5,-4345.7 -3507.8,-4345.7 h -26.6 c -6291.41,0 -3507.9,4345.7 -3507.9,4345.7 0,3882.2 1782.3,3685.4 1782.3,3685.4 646.2,745.6 1768.2,703 1768.2,703 h -58.6",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14403.2,24942.6 c -108.9,0 -442.5,-27.5 -783.5,-333.8 -426.1,-382.7 -934.2,-1270.8 -934.2,-3328 v -7.3 l -3.9,-6.2 c -10.7,-16.6 -1058.5,-1679.9 -378.5,-2922.7 502.7,-918.7 1803.2,-1384.5 3865.3,-1384.5 h 26.6 c 2062.1,0 3362.5,465.8 3865.2,1384.5 680,1242.8 -367.8,2906.1 -378.5,2922.7 l -3.9,6.2 v 7.3 c 0,2057.2 -508,2945.3 -934.2,3328 -413.8,371.6 -816.6,333 -820.4,332.5 l -13,-1.4 -8.6,9.9 c -548.4,632.7 -1456.6,690.4 -1691.5,694.4 v 0 c -0.5,0 -3.1,0.1 -7.5,0.2 -15.7,0.1 -26.1,0.1 -41.9,0 -4.4,-0.1 -6.9,-0.2 -7.4,-0.2 v 0 c -234.9,-4 -1143.2,-61.7 -1691.5,-694.4 l -8.6,-9.9 -13.1,1.4 c -0.6,0.1 -13.7,1.3 -36.9,1.3 M 16195,16910.1 h -26.6 c -2081.9,0 -3397.2,474.6 -3909.2,1410.7 -672.7,1229.6 305.4,2852.5 376.3,2967.2 1.3,2072.4 518.5,2970.8 952.4,3359.5 393.1,352 768.5,349.1 844.4,344.6 563.3,640.1 1483.7,698.1 1722,702.1 4.4,0.1 14.3,0.4 27.3,0.3 14.4,0.1 23,-0.2 27.4,-0.3 238.3,-3.9 1158.8,-62 1722,-702.1 76.1,4.5 451.5,7.3 844.4,-344.6 434,-388.7 951.2,-1287.1 952.4,-3359.5 71,-114.7 1049,-1737.6 376.3,-2967.2 -512,-936.1 -1827.2,-1410.7 -3909.1,-1410.7",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g86",
    clipPath: "url(#clipPath90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 16533.8,26033.4 c 0,0 -1216.5,-4103.1 1975.2,-5104.5 0,0 1743.6,-218.3 2025.3,-1916.2 150,-904.4 1071.6,1252.9 799.8,3410.2 -238.6,1893 -1396.1,3786 -4800.3,3610.5",
    style: {
      fill: "#d3670d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15910.3,26033.4 c 0,0 1216.5,-4103.1 -1975.2,-5104.5 0,0 -1743.6,-218.3 -2025.3,-1916.2 -150,-904.4 -1071.7,1252.9 -799.8,3410.2 238.6,1893 1396.1,3786 4800.3,3610.5",
    style: {
      fill: "#d3670d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18206.9,17325.6 c 28.8,177.3 46,360.4 50.5,548.2 638.2,455.5 1117.4,1081.1 1117.4,1771.1 0,193.5 -38.9,372.2 -109.3,536.6 -11.8,187 -42.4,370.3 -83.9,544.1 180,-80.2 376.8,-190.4 564.1,-340.9 28.5,-69.7 58.7,-138.8 91.2,-207 76.7,-160.4 162.2,-317.4 258.6,-468.9 65.5,-424.4 43.4,-882 -178.6,-1287.1 -286.2,-522.2 -858.8,-888.5 -1710,-1096.1 m -4078.1,6.9 c -519.9,129.8 -934.3,319.6 -1241.4,568.8 340.6,-96.6 738,-169.4 1200.5,-212.5 8.4,-121.1 22.2,-240 40.9,-356.3",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19745.7,20384.7 c -187.3,150.5 -384.1,260.7 -564.1,340.9 -170.2,711.2 -524.3,1264 -524.3,1264 0,1313.4 -204,2159.6 -473.9,2704.7 l 654.4,-899.8 v 0 c 0.5,0.2 1,0.3 1.6,0.4 l 0.2,-0.4 c 0,0 0.4,0.3 1.2,0.7 10,2.1 19.8,3 29.4,3 34.3,0 65.8,-12.1 91.5,-29.9 l 24.9,-17.4 21.4,-23.1 c 6.8,-8 14.4,-14 20.2,-23 l 17.2,-26.9 c 24.7,-32.3 40.3,-75.5 59.6,-111.8 14.3,-42 29.3,-82 42.4,-123.5 52.4,-166.8 76.5,-346.8 107.1,-522 10.1,-90 23.5,-178.6 34.4,-268 9.7,-90.1 18.1,-180.2 29.5,-269.8 15.7,-182.7 33.1,-356.7 54.8,-550.5 47.3,-378.6 128.8,-753.7 250.3,-1118 37.7,-110.8 77.8,-220.9 122.2,-329.6",
    style: {
      fill: "#93482b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 16195,16747.3 h -26.6 c -2146,0 -3509.3,503.1 -4052,1495.4 -739.9,1352.6 339.7,3067.1 386,3139.4 56,87.3 172.2,112.7 259.4,56.8 87.3,-55.9 112.8,-172 56.9,-259.4 -10.1,-15.7 -1006.1,-1601.2 -372.3,-2757.8 472.4,-861.9 1724.6,-1298.9 3722,-1298.9 h 26.6 c 1997.3,0 3249.5,437 3721.9,1298.9 633.9,1156.6 -362.2,2742.1 -372.3,2758 -55.7,87.3 -30.2,203.4 57.1,259.2 87.3,55.9 203.3,30.4 259.2,-56.8 46.3,-72.3 1126,-1786.8 386.1,-3139.4 -542.8,-992.3 -1906.1,-1495.4 -4052,-1495.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17920.6,24778.4 c -52.6,0 -104.9,22 -142,64.8 -500.8,577.8 -1342.8,633.8 -1564.6,638.2 -1,0 -2,0 -3,0 h -58.7 c -1.1,0 -2.2,0 -3.3,0 -221.8,-4.4 -1063.6,-60.5 -1564.2,-638.2 -68,-78.3 -186.6,-86.8 -264.9,-18.9 -78.3,67.9 -86.8,186.5 -18.9,264.8 637.4,735.6 1671.1,767.2 1880.7,768.3 210.2,-0.2 1243.3,-32.8 1880.7,-768.3 67.9,-78.3 59.4,-196.9 -19,-264.8 -35.5,-30.8 -79.3,-45.9 -122.8,-45.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14442.8,24966.2 c 0,0 -1107.7,1022.5 -3238,106.5 -2130.21,-916 -3023.9,-5353.5 -1320.71,-6156.5 1491.21,-703 2790.61,1043.9 3003.71,3110.2 213,2066.4 702.9,1768.1 702.9,1768.1 l 852.1,1171.7",
    style: {
      fill: "#d3670d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10518.2,18758.2 c -8.6,0 -17.3,0.1 -25.9,0.2 5.5,0.1 11.1,0.2 16.6,0.3 6.2,-0.2 12.6,-0.4 18.8,-0.5 -3.1,0 -6.3,0 -9.5,0",
    style: {
      fill: "#85e5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10527.7,18758.2 c -6.2,0.1 -12.6,0.3 -18.8,0.5 102.9,2.4 204,16 302.9,40.2 7.2,-1.8 14.4,-3.4 21.6,-5 -99.9,-22.8 -201.8,-35 -305.7,-35.7",
    style: {
      fill: "#e9b386",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10127.9,18811.9 c -92.4,25.3 -185.84,59.9 -280,104.3 -1703.19,803 -809.5,5240.5 1320.8,6156.5 658.9,283.3 1219.8,381.1 1680.4,381.1 2.1,0 4.1,0 6.1,0 -455,-4.2 -1005.7,-103.9 -1650.4,-381.1 -2130.21,-916 -3023.9,-5353.5 -1320.71,-6156.5 88.01,-41.5 175.31,-74.4 261.81,-99.3 -6,-1.7 -12,-3.4 -18,-5",
    style: {
      fill: "#85e5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10145.9,18816.9 c -86.5,24.9 -173.8,57.8 -261.81,99.3 -1703.19,803 -809.5,5240.5 1320.71,6156.5 644.7,277.2 1195.4,376.9 1650.4,381.1 107.5,-0.2 209.5,-5.8 306,-15.5 -393.2,-37.1 -846.7,-145 -1359.6,-365.6 -2120.68,-911.9 -3015.76,-5313.6 -1343.6,-6145.4 -102,-43.9 -206.2,-80.4 -312.1,-110.4",
    style: {
      fill: "#e9b386",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10476.4,18758.3 c -120.7,0 -244,15.6 -369,48 6.8,1.8 13.7,3.7 20.5,5.6 123.4,-33.9 245,-51.3 364.4,-53.5 -5.3,0 -10.6,-0.1 -15.9,-0.1",
    style: {
      fill: "#0ab6f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10811.8,18798.9 c -109,26 -219.4,64.7 -331,117.3 -7.7,3.7 -15.2,7.3 -22.8,11.1 858.2,368.6 1561.1,1252.8 1816.2,3081.2 165.6,1186.7 755.7,1645.2 1058,1763 -161.9,-106.8 -393.6,-489.3 -523.1,-1745.1 -163,-1581.5 -962.5,-2975.5 -1997.3,-3227.5",
    style: {
      fill: "#bd5c18",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13497.1,23801.2 c -4.2,1.3 -9.1,2.2 -14.8,2.8 1,0.2 2.1,0.5 3.1,0.7 4.5,-1.1 8.4,-2.3 11.7,-3.5",
    style: {
      fill: "#bd5c18",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13332.2,23771.5 c 44.8,29.6 84.2,38 114.7,38 15.3,0 28.3,-2.1 38.5,-4.8 -1,-0.2 -2.1,-0.5 -3.1,-0.7 -3.6,0.3 -7.5,0.5 -11.6,0.5 -31.8,0 -79.7,-10.1 -138.5,-33",
    style: {
      fill: "#bd5c18",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13501.7,23799.4 c -1.4,0.6 -2.9,1.2 -4.6,1.8 1.7,-0.6 3.2,-1.1 4.6,-1.8",
    style: {
      fill: "#bd5c18",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10492.3,18758.4 c -119.4,2.2 -241,19.6 -364.4,53.5 6,1.6 12,3.3 18,5 122.9,-35.3 244,-54.3 363,-58.2 -5.5,-0.1 -11.1,-0.2 -16.6,-0.3",
    style: {
      fill: "#77cdf0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10508.9,18758.7 c -119,3.9 -240.1,22.9 -363,58.2 105.9,30 210.1,66.5 312.1,110.4 7.6,-3.8 15.1,-7.4 22.8,-11.1 111.6,-52.6 222,-91.3 331,-117.3 -98.9,-24.2 -200,-37.8 -302.9,-40.2",
    style: {
      fill: "#d0a084",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14316.7,24829.6 -6.6,5.7 -11.1,8.7 -22.1,17.6 -49.2,35.2 c -34.7,22.1 -68.8,45.6 -105.6,65.9 -72.4,42.3 -149.3,78.4 -227.1,112.9 l -119.4,46.1 c -39.6,15.8 -81.8,25.5 -122.5,38.7 -81.1,28.1 -166.7,41.5 -250.5,61.2 -84.7,15.8 -171.2,24 -256.8,36.2 -86.8,3.4 -173.5,9.3 -260.5,11.2 l -261.9,-10.1 -261.4,-32.6 c -43.8,-3.5 -86.6,-16.1 -129.9,-24.3 l -129.7,-27.4 c -43,-10.1 -86.8,-15.7 -129.2,-29.5 l -127.6,-38.2 -127.7,-38 -63.8,-18.9 -62.5,-24 -249.9,-96.3 -62.5,-24 -57.8,-26.7 c -38.9,-16.8 -75.9,-38.2 -113.7,-57.4 -74.4,-41.5 -147.4,-86 -217.3,-136.1 -140.4,-99 -272.4,-212.5 -393.6,-338.2 -243.2,-251 -449.4,-542.4 -621.29,-853.6 -172.24,-311.3 -312.16,-642.2 -421.43,-982.8 -107.86,-341.1 -184.77,-692.1 -226.93,-1045.7 -42.04,-353.2 -47.66,-710.3 -2.66,-1055.3 45.99,-343.1 146.34,-679.1 330.08,-941.7 45.33,-65.8 97.09,-125.1 153.32,-178.2 56.12,-53.2 116.72,-100.6 182.86,-138.5 15.89,-10.6 33.08,-18.9 50.05,-27.5 17.09,-8.6 33.05,-18 52.75,-25.4 37.85,-15.2 75.15,-32.5 113.05,-46.6 l 115.2,-36.8 116.7,-26.2 c 312.9,-57.7 633.5,18.3 910.8,193.2 278,174.1 517.7,428.8 710.1,717.9 193.3,289.6 346.1,610.9 465.8,945 119.3,334.6 202.9,683.4 254.4,1037.1 l 36.4,271.1 c 12.9,93.1 25.5,186.1 41.9,278.8 17.2,93 37.3,185.4 56.3,277.9 23.1,92.2 47.9,184.3 73.7,275.5 60.5,182.2 123.3,363.9 227.5,533.1 25.3,42.4 57.3,82.3 85.2,122.3 l 51.4,56.5 c 8.7,9.2 16.4,18.7 26,27.3 10,8.5 20.3,16.6 30.6,24.5 l 30.5,23.3 c 10.1,7.7 23.1,13.1 34.4,19.4 l 34.6,17.6 38.3,10.9 c 50.8,11.1 107.1,4.7 144.3,-25.9 -46.6,10.7 -90.3,-2.9 -123.9,-26.2 l -24.9,-17.5 -21.4,-23 c -6.8,-8 -14.4,-14 -20.2,-23 l -17.2,-26.9 c -24.7,-32.3 -40.3,-75.5 -59.6,-111.8 -14.3,-42 -29.3,-82 -42.4,-123.5 -52.4,-166.8 -76.5,-346.8 -107.1,-522 -10.1,-90 -23.5,-178.7 -34.4,-268 -9.7,-90.1 -18.1,-180.2 -29.5,-269.8 -15.7,-182.7 -33.1,-356.7 -54.8,-550.5 -47.3,-378.6 -128.8,-753.7 -250.3,-1118 -61.8,-181.7 -130.2,-362 -213.4,-536.6 -83.4,-174.4 -177.2,-344.9 -284.2,-508.6 -106.5,-163.9 -228.3,-320.1 -365.9,-464.5 -137.8,-144.1 -292.3,-277 -467.7,-384.8 -174.7,-108.2 -369.9,-192.3 -577.3,-236.7 -207.1,-45 -424.9,-48.2 -632.4,-10.3 -51.4,10.8 -102.5,23.1 -153.6,35 -49.9,15 -99.2,31.8 -148.68,47.9 -48.47,18.2 -95.29,39.5 -142.9,59.4 -23.49,9.2 -47.88,22.6 -71.92,34.9 -24.12,12.5 -48.32,24.7 -71.15,39.5 -93.89,54.6 -179.85,122 -257.42,196 -77.76,73.9 -147.39,155.3 -206.81,241.6 -120.36,172.2 -207.59,360.1 -269.02,551.1 -62.84,191.2 -100.58,385.8 -124.88,580 -46.02,388.7 -34.2,776.3 15.21,1155.9 49.64,379.9 136.45,752.7 255.03,1115.1 118.71,362.3 269.85,714.5 457.38,1048.8 187.37,334.1 412.89,650.6 685.96,929.1 136.1,139.5 286.1,267.4 448.3,380.4 80.7,56.9 165.9,108.3 253.2,156.2 44.5,22.6 88,46.9 134,66.8 l 68.2,30.9 66.7,25.9 267.1,103.6 66.9,25.6 68.9,20.7 137.9,41.4 137.8,41.3 c 45.7,14.8 93.9,21.6 140.7,32.7 l 141.5,30.1 c 47.4,9.1 93.8,22.4 142.3,26.7 l 288.5,36.4 292,11.8 c 97.6,-1.7 195.5,-7.9 293.2,-12.1 97.3,-13 195.2,-22.6 291.9,-40.5 96.2,-21.8 193.6,-37.8 287.8,-69.5 47.1,-15.1 95.3,-26.7 141.6,-44.8 l 139.2,-53.5 c 91.3,-39.9 181.8,-82.5 269.2,-133.1 44,-24.4 86.5,-53.1 129.5,-80.7 43.7,-31 81.3,-56.7 131.2,-100.6 77.1,-67.8 84.6,-185.2 16.8,-262.2 -67.2,-76.5 -183.3,-84.5 -260.4,-18.4 l -8.6,7.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17985.7,24966.2 c 0,0 1107.7,1022.5 3238,106.5 2130.2,-916 3023.9,-5353.5 1320.7,-6156.5 -1491.2,-703 -2790.6,1043.9 -3003.6,3110.2 -213.1,2066.4 -703,1768.1 -703,1768.1 l -852.1,1171.7",
    style: {
      fill: "#d3670d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23229.4,21137.9 -177.2,121.8 c -174,1469.6 -980.7,3097.9 -2178.5,3613 -127.9,55 -252.1,103 -372.6,144.6 40.5,26.9 82.2,52.4 125.1,76.7 l 84.4,-25.1 63.8,-18.9 62.5,-24 249.9,-96.3 62.5,-24 57.9,-26.7 c 38.8,-16.8 75.8,-38.2 113.6,-57.4 74.4,-41.5 147.4,-86 217.4,-136.1 140.3,-99 272.3,-212.5 393.5,-338.2 243.2,-251 449.4,-542.4 621.3,-853.6 172.2,-311.3 312.1,-642.2 421.4,-982.8 107.9,-341.1 184.8,-692.1 226.9,-1045.7 13,-108.9 22.5,-218.1 28.1,-327.3",
    style: {
      fill: "#e9b386",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17859.6,25102.8 c 49.9,43.9 87.5,69.6 131.2,100.6 43,27.6 85.5,56.3 129.6,80.7 87.3,50.6 177.8,93.2 269.1,133.1 l 139.2,53.5 c 46.3,18.1 94.4,29.7 141.6,44.8 94.2,31.7 191.6,47.7 287.8,69.5 96.7,17.9 194.6,27.5 291.9,40.5 97.7,4.2 195.6,10.4 293.2,12.1 l 292,-11.8 288.5,-36.4 c 48.5,-4.3 94.9,-17.6 142.3,-26.7 l 141.5,-30.1 c 46.8,-11.1 95,-17.9 140.6,-32.7 l 138,-41.3 137.8,-41.4 68.9,-20.7 66.9,-25.6 267.1,-103.6 66.7,-25.9 68.2,-30.9 c 46.1,-19.9 89.5,-44.2 134.1,-66.8 87.2,-47.9 172.4,-99.3 253.1,-156.2 162.2,-113 312.2,-240.9 448.3,-380.4 273.1,-278.5 498.6,-595 686,-929.1 187.5,-334.3 338.6,-686.5 457.3,-1048.8 118.6,-362.4 205.4,-735.2 255.1,-1115.1 49.4,-379.6 61.2,-767.2 15.2,-1155.9 -24.3,-194.2 -62.1,-388.8 -124.9,-580 -61.4,-191 -148.6,-378.9 -269,-551.1 -59.4,-86.3 -129.1,-167.7 -206.8,-241.6 -77.6,-74 -163.6,-141.4 -257.4,-196 -22.9,-14.8 -47.1,-27 -71.2,-39.5 -24,-12.3 -48.4,-25.7 -71.9,-34.9 -47.6,-19.9 -94.4,-41.2 -142.9,-59.3 -49.5,-16.2 -98.8,-33 -148.7,-48 -51.1,-11.9 -102.2,-24.2 -153.6,-35 -207.4,-37.9 -425.3,-34.7 -632.4,10.3 -207.4,44.4 -402.6,128.5 -577.3,236.7 -175.4,107.8 -329.9,240.7 -467.7,384.8 -137.6,144.4 -259.4,300.6 -365.9,464.5 -106.9,163.7 -200.8,334.2 -284.2,508.6 -83.2,174.6 -151.6,354.9 -213.4,536.6 -121.5,364.3 -203,739.4 -250.3,1118 -21.7,193.8 -39.1,367.8 -54.8,550.5 -11.4,89.6 -19.8,179.7 -29.5,269.8 -10.9,89.4 -24.3,178 -34.4,268 -30.6,175.2 -54.7,355.2 -107.1,522 -13.1,41.5 -28.1,81.5 -42.4,123.5 -19.3,36.3 -34.9,79.5 -59.6,111.8 l -17.2,26.9 c -5.8,9 -13.4,15 -20.2,23 l -21.4,23.1 -24.9,17.4 c -33.6,23.3 -77.3,36.9 -123.9,26.2 37.2,30.6 93.5,37 144.3,25.9 l 38.3,-10.9 34.6,-17.6 c 11.3,-6.3 24.3,-11.7 34.5,-19.4 l 30.4,-23.4 c 10.3,-7.8 20.6,-15.9 30.6,-24.4 9.6,-8.6 17.3,-18.1 26,-27.3 l 51.4,-56.5 c 27.9,-40 59.9,-79.9 85.2,-122.3 104.2,-169.2 167,-350.9 227.5,-533.1 25.8,-91.2 50.7,-183.3 73.7,-275.5 19,-92.5 39.1,-184.9 56.3,-277.9 16.4,-92.7 29.1,-185.7 41.9,-278.8 l 36.4,-271.1 c 51.5,-353.7 135.1,-702.5 254.4,-1037.1 119.7,-334.1 272.5,-655.4 465.7,-945 192.5,-289.1 432.2,-543.7 710.2,-717.9 277.2,-174.9 597.8,-250.9 910.8,-193.2 l 116.7,26.2 115.1,36.8 c 38.1,14.1 75.3,31.4 113.1,46.6 19.8,7.4 35.7,16.8 52.8,25.4 17,8.6 34.2,16.9 50.1,27.5 66.1,37.9 126.7,85.3 182.8,138.5 56.3,53.1 108,112.4 153.4,178.3 183.7,262.5 284,598.5 330,941.6 45,345 39.4,702.1 -2.7,1055.3 -42.1,353.6 -119,704.6 -226.9,1045.7 -109.3,340.6 -249.2,671.5 -421.4,982.8 -171.9,311.2 -378.1,602.6 -621.3,853.6 -121.2,125.7 -253.2,239.2 -393.5,338.2 -70,50.1 -143,94.6 -217.4,136.1 -37.8,19.2 -74.8,40.6 -113.6,57.4 l -57.9,26.7 -62.5,24 -249.9,96.3 -62.5,24 -63.8,18.9 -127.7,38 -127.6,38.2 c -42.4,13.8 -86.2,19.4 -129.3,29.5 l -129.6,27.4 c -43.2,8.2 -86.1,20.8 -129.9,24.3 l -261.4,32.6 -261.9,10.1 c -87,-1.9 -173.6,-7.8 -260.5,-11.2 -85.6,-12.2 -172.1,-20.4 -256.8,-36.2 -83.7,-19.7 -169.4,-33.1 -250.5,-61.1 -40.7,-13.3 -82.8,-23 -122.5,-38.8 l -119.5,-46.1 c -77.7,-34.5 -154.5,-70.6 -227,-112.9 -36.8,-20.3 -70.9,-43.8 -105.6,-65.9 l -49.2,-35.2 -22.1,-17.6 -11.1,-8.7 -6.6,-5.7 -8.5,-7.3 c -77.8,-66.8 -195.1,-57.9 -262,19.9 -66.3,77.3 -58,193.5 18.3,260.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18070.9,17972.6 c 0,-1508.3 -851.8,-2731.1 -1902.5,-2731.1 -1050.8,0 -1902.6,1222.8 -1902.6,2731.1 0,1508.3 851.8,2731 1902.6,2731 1050.7,0 1902.5,-1222.7 1902.5,-2731",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16168.4,20678.6 c -1035.3,0 -1877.5,-1213.9 -1877.5,-2706 0,-1492.1 842.2,-2706.1 1877.5,-2706.1 1035.2,0 1877.4,1214 1877.4,2706.1 0,1492.1 -842.2,2706 -1877.4,2706 m 0,-5462.1 c -1062.9,0 -1927.5,1236.4 -1927.5,2756.1 0,1519.7 864.6,2756 1927.5,2756 1062.8,0 1927.5,-1236.3 1927.5,-2756 0,-1519.7 -864.7,-2756.1 -1927.5,-2756.1",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16168.4,20515.9 c -945.6,0 -1714.8,-1140.9 -1714.8,-2543.3 0,-1402.4 769.2,-2543.3 1714.8,-2543.3 945.5,0 1714.7,1140.9 1714.7,2543.3 0,1402.4 -769.2,2543.3 -1714.7,2543.3 m 0,-5462.1 c -1152.6,0 -2090.3,1309.4 -2090.3,2918.8 0,1609.4 937.7,2918.8 2090.3,2918.8 1152.5,0 2090.2,-1309.4 2090.2,-2918.8 0,-1609.4 -937.7,-2918.8 -2090.2,-2918.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17487.3,17261.7 c 0,-737.3 -597.7,-1334.9 -1334.9,-1334.9 -737.3,0 -1335,597.6 -1335,1334.9 0,737.3 597.7,1335 1335,1335 737.2,0 1334.9,-597.7 1334.9,-1335",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.4,13452.1 c 953.2,0 1517.8,734.9 1283.4,2215.5 -31.5,198.9 -77.7,383.5 -134.1,553.9 -365.4,1103.9 -1933.3,1103.9 -2298.7,0 -56.4,-170.4 -102.6,-355 -134.1,-553.9 -234.3,-1480.6 330.2,-2215.5 1283.5,-2215.5",
    style: {
      fill: "#ed2a84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.4,17024.4 c -520.8,0.1 -962.7,-318.2 -1125.7,-810.8 -58.6,-177 -103.4,-362 -133.1,-549.9 -125.8,-794.8 -23.7,-1412.2 295.2,-1785.6 224.1,-262.4 557.3,-401 963.5,-401 406.3,0 739.5,138.7 963.6,401 318.9,373.4 421,990.8 295.2,1785.6 -29.7,187.7 -74.5,372.7 -133.1,549.9 -163.1,492.6 -604.9,810.8 -1125.6,810.8 m -0.1,-3597.3 c -421.3,0 -767.6,144.7 -1001.5,418.5 -328.7,384.9 -434.7,1016.2 -306.6,1825.9 30.2,190.6 75.6,378.3 135,557.9 170,513.3 630.5,845 1173.1,845 h 0.1 c 542.7,0 1003.1,-331.7 1173,-845 59.6,-179.8 105,-367.5 135.1,-557.9 128.2,-809.6 22.2,-1441 -306.6,-1825.9 -233.9,-273.8 -580.2,-418.5 -1001.6,-418.5",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17300.3,15109.8 c -20.2,79 -42.7,155.3 -67.1,228.9 -160.2,484.2 -551.8,756 -971.8,815.5 11.2,127.1 21.2,254.3 29.9,381.5 10.9,159.1 20.8,318.3 28.7,477.5 180,-24.3 346.9,-87.7 491.7,-183.5 190.1,-309.1 361.7,-705.1 438.7,-1191.5 29.7,-187.4 46.2,-363.9 49.9,-528.4",
    style: {
      fill: "#a51d7f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16750.9,16924.8 c -130.3,70.9 -274.9,118.4 -428.5,138.6 0.5,10.9 1,21.9 1.5,32.8 148.8,-24 292,-77.3 419.9,-160.8 2.4,-3.6 4.8,-7.1 7.1,-10.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16811.7,16829.7 c -144.8,95.8 -311.7,159.2 -491.7,183.5 0.8,16.8 1.6,33.5 2.4,50.2 153.6,-20.2 298.2,-67.7 428.5,-138.6 20.4,-30.7 40.7,-62.4 60.8,-95.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15046.5,15586.6 c 2.5,17.1 5.1,34.3 7.8,51.6 77,486.4 248.7,882.5 438.8,1191.6 144.7,95.7 311.6,159.1 491.7,183.4 7.8,-159.1 17.8,-318.4 28.6,-477.5 8.5,-123.3 18.1,-246.5 28.9,-369.7 -390.5,-12.8 -775.4,-205.9 -995.8,-579.4",
    style: {
      fill: "#a51d7f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15553.8,16924.7 c 13.9,20.9 27.8,41.4 41.8,61.5 122.9,59.3 253.3,97.8 385.1,114.8 0.5,-12.5 1.1,-25.1 1.7,-37.6 -153.7,-20.2 -298.3,-67.7 -428.6,-138.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15493.1,16829.8 c 20,32.6 40.3,64.3 60.7,94.9 130.3,71 274.9,118.5 428.6,138.7 0.7,-16.7 1.5,-33.4 2.4,-50.2 -180.1,-24.3 -347,-87.7 -491.7,-183.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16340.1,17829.8 c 2.3,-215.7 -3.9,-431.4 -12.6,-647.1 -8.4,-215.7 -21.5,-431.4 -36.2,-647 -14.8,-215.7 -33,-431.4 -55.2,-647.1 -22.2,-215.7 -48.2,-431.4 -83.7,-647.1 -35.6,215.7 -61.6,431.4 -83.8,647.1 -22.1,215.7 -40.4,431.4 -55.2,647.1 -14.7,215.6 -27.8,431.3 -36.1,647 -8.8,215.7 -15,431.4 -12.7,647.1 1.1,103.7 86,186.9 189.7,185.8 102.3,-1.1 184.7,-84 185.8,-185.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.3,17594.7 c -257.3,-210.2 -922.8,-849.7 -1098,-1956.5 -118.1,-746.3 -28.8,-1318.3 258.3,-1654.4 194.9,-228.2 477.4,-344 839.7,-344 362.3,0 644.9,115.8 839.8,344 287.1,336.1 376.4,908.2 258.3,1654.4 -175.1,1106.5 -840.4,1746 -1098.1,1956.5 m 0,-4330.3 c -470.4,0 -859.5,164.4 -1125.2,475.5 -360.6,422.2 -479.4,1098.9 -343.7,1957 244.6,1545.4 1320.9,2260.6 1366.6,2290.3 62.3,40.4 142.4,40.4 204.6,0 45.7,-29.7 1122.1,-744.9 1366.7,-2290.3 135.8,-858.1 17,-1534.8 -343.7,-1957 -265.7,-311.1 -654.8,-475.5 -1125.3,-475.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.4,21615 c 1329.9,0 3197.3,-640.2 3197.3,-1970.1 0,-1329.9 -1867.4,-2496.8 -3197.3,-2496.8 -1329.9,0 -3197.4,1166.9 -3197.4,2496.8 0,1329.9 1867.5,1970.1 3197.4,1970.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.3,21590 c -1279.3,0 -3172.3,-618.2 -3172.3,-1945.1 0,-1273.1 1787.1,-2471.8 3172.3,-2471.8 1385.2,0 3172.5,1198.7 3172.5,2471.8 0,1326.9 -1893.1,1945.1 -3172.5,1945.1 m 0,-4466.9 c -1272.5,0 -3222.3,1129.8 -3222.3,2521.8 0,1361 1922.8,1995.1 3222.3,1995.1 1299.6,0 3222.5,-634.1 3222.5,-1995.1 0,-1392 -1949.9,-2521.8 -3222.5,-2521.8",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14080,17848.9 c -274.9,190.1 -521.4,411.2 -716.5,653.6 8.6,-7 17.3,-14.1 26,-21.1 189.8,-234.1 427.4,-446.8 690.4,-630.6 0,-0.7 0.1,-1.2 0.1,-1.9",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14343.9,17680.9 c -90.2,52.8 -178.5,108.9 -263.9,168 0,0.7 -0.1,1.2 -0.1,1.9 85.6,-59.8 173.7,-116.4 264,-169.9",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.3,17173.1 c -875.3,0 -1911.1,478.7 -2555.1,1152.3 624.9,-437.7 1400.1,-714.6 2047.9,-714.6 1329.9,0 3197.4,1166.9 3197.4,2496.8 0,294.6 -92.3,555.1 -249.5,782.6 426.6,-312 712.2,-725.8 712.2,-1245.3 0,-832.7 -732.4,-1601.6 -1606.3,-2060.1 -499.8,-257.1 -1049.1,-411.7 -1546.6,-411.7",
    style: {
      fill: "#b2b2d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16107.8,17148.1 c -552.8,0 -1198.2,201.6 -1763.9,532.8 -90.3,53.5 -178.4,110.1 -264,169.9 -263,183.8 -500.6,396.5 -690.4,630.6 67,-54 136.4,-106.1 207.7,-156 644,-673.6 1679.8,-1152.3 2555.1,-1152.3 497.5,0 1046.8,154.6 1546.6,411.7 -521.8,-273.7 -1093.9,-436.7 -1591.1,-436.7",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16152.3,21440 c -1218.9,0 -3022.3,-570.5 -3022.3,-1795.1 0,-1173.9 1730.6,-2321.8 3022.3,-2321.8 1291.8,0 3022.5,1147.9 3022.5,2321.8 0,1224.6 -1803.6,1795.1 -3022.5,1795.1 z m 0,-4466.9 c -689.4,0 -1532.3,300 -2199.9,782.9 -745.1,539 -1172.4,1227.4 -1172.4,1888.9 0,669.6 413.1,1236.5 1194.8,1639.3 614.5,316.8 1428.5,505.8 2177.5,505.8 749.1,0 1563.1,-189 2177.6,-505.8 781.7,-402.8 1194.9,-969.7 1194.9,-1639.3 0,-661.5 -427.4,-1349.9 -1172.5,-1888.9 -667.5,-482.9 -1510.6,-782.9 -2200,-782.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16211,20912.9 c 0,0 -1739.8,47 -1340.1,-901.2 154,-365.5 388.3,-625 618.2,-806 422.7,-332.8 1021,-332.8 1443.7,0 229.9,181 464.2,440.5 618.3,806 399.7,948.2 -1340.1,901.2 -1340.1,901.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16146.8,20726 c -368,0 -947.5,-81.3 -1106.5,-314.4 -20.6,-30.1 -83,-121.6 3.5,-327 121.2,-287.4 310.1,-533.5 561.4,-731.3 356.7,-280.8 854.8,-280.9 1211.5,-0.1 251.3,197.9 440.2,444 561.4,731.4 86.5,205.4 24.1,297 3.5,327 -167.8,246 -804,323.4 -1165.7,313.6 l -4.9,-0.1 -5.1,0.1 c -18.9,0.5 -38.7,0.8 -59.1,0.8 z m 64.2,-1959.1 c -295.7,-0.1 -591.3,97.1 -838.1,291.3 -301.8,237.6 -528.9,533.9 -675,880.5 -137.4,325.9 -58.2,552.3 32.4,684.9 332.8,487 1341.6,480.6 1480.7,477.1 138.2,3.3 1147.7,9.9 1480.6,-477 90.6,-132.7 169.8,-359.1 32.5,-685 -146.2,-346.6 -373.3,-642.9 -675.2,-880.5 -246.6,-194.2 -542.3,-291.3 -837.9,-291.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17350,20490.4 c 0,-195.1 -280.7,-353.3 -626.9,-353.3 -346.2,0 -626.8,158.2 -626.8,353.3 0,195.1 280.6,353.3 626.8,353.3 346.2,0 626.9,-158.2 626.9,-353.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16723.1,20820.1 c -332.6,0 -603.2,-147.9 -603.2,-329.7 0,-181.8 270.6,-329.7 603.2,-329.7 332.7,0 603.3,147.9 603.3,329.7 0,181.8 -270.6,329.7 -603.3,329.7 z m 0,-706.6 c -358.6,0 -650.4,169.1 -650.4,376.9 0,207.8 291.8,376.9 650.4,376.9 358.7,0 650.5,-169.1 650.5,-376.9 0,-207.8 -291.8,-376.9 -650.5,-376.9",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17095,19834.1 c 0,-86.6 -70.2,-156.7 -156.8,-156.7 -86.5,0 -156.7,70.1 -156.7,156.7 0,86.5 70.2,156.7 156.7,156.7 86.6,0 156.8,-70.2 156.8,-156.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16938.2,19967.2 c -73.4,0 -133.1,-59.7 -133.1,-133.1 0,-73.4 59.7,-133.1 133.1,-133.1 73.5,0 133.2,59.7 133.2,133.1 0,73.4 -59.7,133.1 -133.2,133.1 z m 0,-313.4 c -99.4,0 -180.2,80.9 -180.2,180.3 0,99.4 80.8,180.3 180.2,180.3 99.4,0 180.4,-80.9 180.4,-180.3 0,-99.4 -81,-180.3 -180.4,-180.3",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18839.6,23794.5 -0.2,0.4 c 0.4,0.1 0.9,0.2 1.4,0.3 -0.8,-0.4 -1.2,-0.7 -1.2,-0.7",
    style: {
      fill: "#673240",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21587.9,19006.1 c -142.2,35.1 -280.1,95 -408.7,176.1 -278,174.2 -517.7,428.8 -710.2,717.9 -193.2,289.6 -346,610.9 -465.7,945 -119.3,334.6 -202.9,683.4 -254.4,1037.1 l -36.4,271.1 c -12.8,93.1 -25.5,186.1 -41.9,278.8 -17.2,93 -37.3,185.4 -56.3,277.9 -23,92.2 -47.9,184.3 -73.7,275.5 -60.5,182.2 -123.3,363.9 -227.5,533.1 -25.3,42.4 -57.3,82.3 -85.2,122.3 l -51.4,56.5 c -8.7,9.2 -16.4,18.7 -26,27.3 -10,8.5 -20.3,16.6 -30.6,24.4 l -30.4,23.4 c -10.2,7.7 -23.2,13.1 -34.5,19.4 l -34.6,17.6 -38.3,10.9 c -15.3,3.3 -31,5.1 -46.7,5.1 -35.7,0 -70.6,-9.3 -96.5,-30 l -742.6,1021.1 c 2.4,1.8 4.7,3.7 7,5.7 l 8.5,7.3 6.6,5.7 11.1,8.7 22.1,17.6 49.2,35.2 c 34.7,22.1 68.8,45.6 105.6,65.9 72.5,42.3 149.3,78.4 227,112.9 l 119.5,46.1 c 39.7,15.8 81.8,25.5 122.5,38.8 81.1,28 166.8,41.4 250.5,61.1 74.1,13.8 149.6,21.9 224.6,31.8 358.6,-6.3 775.9,-71.9 1250.6,-236.1 -367.1,-244.4 -627.9,-607 -643.7,-1272.1 -58.9,-2478.1 753.9,-3473.3 1719.9,-3623.4 -39.3,-347.5 -46.2,-728.4 10.6,-1115.7",
    style: {
      fill: "#93482b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20501.1,25017.3 c -474.7,164.2 -892,229.8 -1250.6,236.1 10.7,1.4 21.5,2.9 32.2,4.4 86.9,3.4 173.5,9.3 260.5,11.2 l 261.9,-10.1 261.4,-32.6 c 43.8,-3.5 86.7,-16.1 129.9,-24.3 l 129.6,-27.4 c 43.1,-10.1 86.9,-15.7 129.3,-29.5 l 127.6,-38.2 43.3,-12.9 c -42.9,-24.3 -84.6,-49.8 -125.1,-76.7",
    style: {
      fill: "#a37d80",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21627.3,18780 c -1076.8,192.8 -1917.1,1620.7 -2084.7,3246.4 -165.3,1603.6 -497.4,1783.1 -637.8,1783.1 -35.4,0 -58.7,-11.4 -64,-14.3 -0.5,-0.1 -1,-0.2 -1.4,-0.3 l -0.5,0.6 c 25.9,20.7 60.8,30 96.5,30 15.7,0 31.4,-1.8 46.7,-5.1 l 38.3,-10.9 34.6,-17.6 c 11.3,-6.3 24.3,-11.7 34.5,-19.4 l 30.4,-23.4 c 10.3,-7.8 20.6,-15.9 30.6,-24.4 9.6,-8.6 17.3,-18.1 26,-27.3 l 51.4,-56.5 c 27.9,-40 59.9,-79.9 85.2,-122.3 104.2,-169.2 167,-350.9 227.5,-533.1 25.8,-91.2 50.7,-183.3 73.7,-275.5 19,-92.5 39.1,-184.9 56.3,-277.9 16.4,-92.7 29.1,-185.7 41.9,-278.8 l 36.4,-271.1 c 51.5,-353.7 135.1,-702.5 254.4,-1037.1 119.7,-334.1 272.5,-655.4 465.7,-945 192.5,-289.1 432.2,-543.7 710.2,-717.9 128.6,-81.1 266.5,-141 408.7,-176.1 10.9,-74.8 24.3,-149.8 40.2,-224.9 -0.3,-0.4 -0.5,-0.8 -0.8,-1.2 m -3531,6036.6 -108.8,149.6 c 0,0 528.3,487.5 1557,487.5 373.9,0 814.1,-64.5 1318.9,-240.2 -81.8,-37 -161.3,-76.4 -237.2,-119.5 l -43.3,12.9 -127.6,38.2 c -42.4,13.8 -86.2,19.4 -129.3,29.5 l -129.6,27.4 c -43.2,8.2 -86.1,20.8 -129.9,24.3 l -261.4,32.6 -261.9,10.1 c -87,-1.9 -173.6,-7.8 -260.5,-11.2 -10.7,-1.5 -21.5,-3 -32.2,-4.4 -75,-9.9 -150.5,-18 -224.6,-31.8 -83.7,-19.7 -169.4,-33.1 -250.5,-61.1 -40.7,-13.3 -82.8,-23 -122.5,-38.8 l -119.5,-46.1 c -77.7,-34.5 -154.5,-70.6 -227,-112.9 -36.8,-20.3 -70.9,-43.8 -105.6,-65.9 l -49.2,-35.2 -22.1,-17.6 -11.1,-8.7 -6.6,-5.7 -8.5,-7.3 c -2.3,-2 -4.6,-3.9 -7,-5.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17466,10088.3 c -19,1568.6 111.4,2980.5 111.4,2980.5 L 14747.7,11669 c 0,-1859.2 955,-2977.8 955,-2977.8 h 1853.8 489.4 c 65.2,130.9 101.4,273.5 101.4,423 0,412.3 -272.7,773.5 -681.3,974.1",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14774.2,11673.1 c 127.5,-243.6 206.8,-487.9 290.7,-732.5 l 57.9,-184.2 c 18.8,-61.5 36,-123.4 55.8,-184.6 39.8,-122.4 78.9,-244.9 122.7,-366 82.7,-243.7 174.4,-484.4 269,-723.8 95.9,-237.6 196.9,-478.6 304.4,-704.5 l -172,106.1 1171.6,-12.9 c 390.5,-4 781.1,-4.4 1171.6,-4.5 l -156.6,-97 c 52.2,104.8 80.9,217.9 82.7,332.1 0.7,114.4 -21.9,228.8 -71.7,334.1 -47.9,106.1 -120.9,202.7 -208.2,286.7 -88,83.7 -191.8,153.2 -303.2,209.1 l -2.5,1.2 c -60.2,30.2 -95,90.8 -95.4,153.7 l -3.6,853.1 c 0.8,284 8.3,568 31.3,850.8 22.1,282.9 56.1,564.9 96.9,845.9 43.8,280.9 93.6,561.1 167.5,838.6 3.8,14.5 18.8,23.2 33.3,19.3 11.3,-3 19.1,-13 20.1,-24.1 25.4,-285 34.4,-568.1 41.5,-850.7 4.5,-282.4 7.5,-564.3 3.7,-845.5 -3.6,-281.3 -13.9,-561.8 -26.5,-842.3 -12.3,-280.4 -17.1,-560.8 -14.2,-840.8 l -97.9,155 c 140.6,-70.3 273.8,-159 390.3,-269.8 115.8,-111.1 216.4,-243 285,-394.2 70.6,-149.7 105.4,-318.9 103.6,-486.1 -2.5,-167.9 -45.7,-334.7 -119.4,-482.1 l -0.2,-0.3 c -30.6,-61.2 -92.4,-96.5 -156.5,-96.7 -390.5,0 -781.1,-0.4 -1171.6,-4.5 l -1171.6,-12.9 c -75,-0.8 -140.2,42.1 -171.5,105.1 l -0.5,1.1 c -120.9,244.5 -226.5,484.3 -324.1,732.4 -99,246.4 -184,498.1 -263.8,751.4 -39.3,126.8 -73.9,255.2 -109,383.3 -32.3,129 -68,257.1 -89.1,388.9 -11.2,65.7 -21.3,131.6 -29.5,197.8 -6.9,66.5 -11.2,133.6 -14.7,200.5 -7.7,133.5 1.4,270 20.7,405.6 2.2,15.3 16.4,26 31.7,23.8 9.2,-1.3 16.8,-7 20.8,-14.6 l 0.5,-1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17930.1,8866.3 c -351.9,0.1 -703.9,0.8 -1055.8,4.4 l -1048.5,11.6 c -89.4,194.8 -174.3,398.5 -255.5,599.7 -94.6,239.4 -186.3,480.1 -269,723.8 -43.8,121.1 -82.9,243.6 -122.7,366 -19.8,61.2 -37,123.1 -55.8,184.6 l -57.9,184.2 c -83.9,244.6 -163.2,488.9 -290.7,732.5 l -0.5,1 c -1.1,2.1 -2.5,4 -4,5.8 l 2711.6,1341.3 c -24.4,-128.1 -45.7,-256.6 -65.7,-385.3 -39.5,-272.2 -72.6,-545.4 -94.8,-819.3 -100.1,29.7 -212.3,46.8 -338.5,47.5 -1.5,0 -2.9,0 -4.4,0 -1146.3,0 -1426.5,-2325.5 -934.3,-2748.9 181.2,-155.9 531.4,-226.8 895.3,-226.8 394.2,0 804.4,83.2 1033,231.3 0.1,-6.1 0.2,-12.2 0.1,-18.4 -1.2,-79.7 -15.6,-158.9 -41.9,-235",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18045.9,8691.2 h -2343.2 c 0,0 -955,1118.6 -955,2977.8 l 22,10.9 c 1.5,-1.8 2.9,-3.7 4,-5.8 l 0.5,-1 c 127.5,-243.6 206.8,-487.9 290.7,-732.5 l 57.9,-184.2 c 18.8,-61.5 36,-123.4 55.8,-184.6 39.8,-122.4 78.9,-244.9 122.7,-366 82.7,-243.7 174.4,-484.4 269,-723.8 81.2,-201.2 166.1,-404.9 255.5,-599.7 l 1048.5,-11.6 c 351.9,-3.6 703.9,-4.3 1055.8,-4.4 26.3,76.1 40.7,155.3 41.9,235 0.1,6.2 0,12.3 -0.1,18.4 74.6,48.3 129.9,103.6 159,165.1 10.4,-55.7 16.4,-112.6 16.4,-170.6 0,-149.5 -36.2,-292.1 -101.4,-423 m -2171.2,86.3 v 0 m 1619.4,2969.9 c -53.4,27.3 -111,50.7 -173.3,69.2 22.2,273.9 55.3,547.1 94.8,819.3 20,128.7 41.3,257.2 65.7,385.3 l 96.1,47.6 c 0,0 -49.8,-539.4 -83.3,-1321.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13088.4,8878.7 h -1794.8 c -11.4,4.7 -23.7,9.9 -34.9,14.9 -22.3,9.8 -44.8,20.3 -67.2,31.2 -44.9,21.6 -89.5,45.2 -133.6,69.7 -88,49.5 -174,103.8 -257.3,162 -166.1,117.2 -320.6,250.9 -460.5,398.1 -280.6,294.3 -496.01,646.5 -639.63,1027.4 -69.44,191.6 -121.27,389.7 -158.97,591.2 l -22.02,152.5 -10.91,76.3 -6.3,77 -12.84,154 -3.94,155 c -2.49,127.3 0.43,254.8 8.25,382.4 98.89,-483.3 338.43,-981.2 905.86,-981.1 6.8,0 13.7,0 20.6,0.2 1316.2,27.4 1773.5,1090 2542.3,1090 51.2,0 103.7,-4.7 158,-14.7 166.7,-87.7 318.1,-191.3 446,-309.4 -35.8,6.7 -74,10.5 -114.6,10.5 -129,0 -282.3,-38.2 -460.3,-142.8 -498.3,-292.9 -290.5,-1317.3 -207.7,-1634.1 -125.7,-39.9 -249.3,-86.2 -370.9,-139.5 -26.5,-11.5 -42.3,-40.4 -36.3,-69.9 6.1,-29.7 32.2,-50.2 61.4,-50.2 4.1,0 8.4,0.5 12.6,1.3 l 2.9,0.6 c 95.2,19.5 191.1,37.4 287.4,53.1 -67.8,-135.4 -56.7,-268.9 149.3,-349.9 209.4,-82.4 412.2,-158.9 581.6,-272.6 3.8,-26 6.6,-52 8.5,-77.9 4.4,-60.5 3.7,-120.5 -2.7,-178.8 -6,-58.2 -16.4,-114.8 -32.9,-168.6 -5.3,-19.2 -11.5,-38 -18.4,-56.5 l -338,-1.4 m 589.8,2.5 c -1.3,14.2 -2.9,28.4 -5,42.4 -8.1,68.9 -23.8,135.7 -44,199.5 -19.1,61.6 -43.7,120.4 -72.4,176.1 126.2,-102.8 227.7,-234.5 290.7,-417.3 l -169.3,-0.7",
    style: {
      fill: "#b2b2d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13895.5,8691.2 H 13679 c 1,6.4 1.7,12.9 1.9,19.5 l 0.1,1.4 c 2.1,57.3 2.2,113.7 -2.8,169.1 l 169.3,0.7 c 20.1,-58.1 36.2,-121.5 48,-190.7 m -524.3,0 h -2113.1 c 0,0 -2575.65,916 -1825.72,4377.6 0,0 -31.9,-442.7 61.36,-898.4 -7.82,-127.6 -10.74,-255.1 -8.25,-382.4 l 3.94,-155 12.84,-154 6.3,-77 10.91,-76.3 22.02,-152.5 c 37.7,-201.5 89.53,-399.6 158.97,-591.2 143.62,-380.9 359.03,-733.1 639.63,-1027.4 139.9,-147.2 294.4,-280.9 460.5,-398.1 83.3,-58.2 169.3,-112.5 257.3,-162 44.1,-24.5 88.7,-48.1 133.6,-69.7 22.4,-10.9 44.9,-21.4 67.2,-31.2 11.2,-5 23.5,-10.2 34.9,-14.9 h 1794.8 l 338,1.4 c -12.5,-33.3 -27.2,-65.4 -42,-96.4 -8.8,-18.5 -14.4,-39.8 -15.1,-61.6 -0.4,-10.5 0.2,-20.9 1.9,-30.9 m -933.1,1238.2 c -29.2,0 -55.3,20.5 -61.4,50.2 -6,29.5 9.8,58.4 36.3,69.9 121.6,53.3 245.2,99.6 370.9,139.5 15.5,-59.6 26.7,-94.3 27.9,-94.2 v 0 c -27.9,-36.3 -52.3,-73.4 -70.8,-110.4 -96.3,-15.7 -192.2,-33.6 -287.4,-53.1 l -2.9,-0.6 c -4.2,-0.8 -8.5,-1.3 -12.6,-1.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13679,8691.2 h -307.8 c -1.7,10 -2.3,20.4 -1.9,30.9 0.7,21.8 6.3,43.1 15.1,61.6 14.8,31 29.5,63.1 42,96.4 6.9,18.5 13.1,37.3 18.4,56.5 16.5,53.8 26.9,110.4 32.9,168.6 6.4,58.3 7.1,118.3 2.7,178.8 -1.9,25.9 -4.7,51.9 -8.5,77.9 29.3,-19.7 57.7,-40.6 84.9,-62.7 28.7,-55.7 53.3,-114.5 72.4,-176.1 20.2,-63.8 35.9,-130.6 44,-199.5 2.1,-14 3.7,-28.2 5,-42.4 5,-55.4 4.9,-111.8 2.8,-169.1 l -0.1,-1.4 c -0.2,-6.6 -0.9,-13.1 -1.9,-19.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14039.2,11045.3 -67.4,641.8 c 0,0 -133.7,217.7 -405.3,268.3 -127.9,118.1 -279.3,221.7 -446,309.4 148.3,-27.4 309.5,-94.6 490.6,-214.2 540.4,-356.9 596,-702.4 428.1,-1005.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17084.9,22234.8 c 170.1,-391.5 545.5,-560.9 838.5,-378.3 293.1,182.7 392.7,648.2 222.6,1039.8 -170.1,391.5 -545.5,560.9 -838.5,378.3 -293,-182.7 -392.7,-648.2 -222.6,-1039.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17559.5,23338 c -86.1,0 -169.6,-24.2 -246.6,-72.2 -288.3,-179.7 -386.4,-640.4 -218.5,-1026.8 92.2,-212.4 249.1,-366.5 430.3,-423 137.2,-42.7 273.1,-25.6 393.3,49.3 288.3,179.7 386.4,640.4 218.6,1026.8 -92.3,212.4 -249.1,366.5 -430.4,423 -49.3,15.3 -98.4,22.9 -146.7,22.9 z m 110.4,-1565.1 c -50.2,0 -101.1,7.7 -151.3,23.4 -187,58.2 -348.5,216.6 -443.2,434.4 -171.8,395.5 -70.1,867.7 226.6,1052.6 123.7,77.1 269.4,95.4 410.4,51.5 187,-58.2 348.5,-216.5 443.1,-434.4 171.8,-395.5 70.1,-867.7 -226.6,-1052.6 -79.6,-49.7 -168.3,-74.9 -259,-74.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17222.4,22646.5 c 27.9,-147.2 121.4,-248.5 208.8,-226.3 87.4,22.2 135.6,159.6 107.7,306.7 -28,147.2 -121.4,248.5 -208.8,226.3 -87.4,-22.2 -135.7,-159.5 -107.7,-306.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17859.4,22383.2 c 17.7,-72.8 67.2,-121.7 110.4,-109.1 43.2,12.5 63.8,81.8 46.1,154.6 -17.8,72.8 -67.2,121.7 -110.4,109.1 -43.3,-12.5 -63.9,-81.7 -46.1,-154.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15346,22234.8 c -170.1,-391.5 -545.5,-560.9 -838.5,-378.3 -293,182.7 -392.7,648.2 -222.6,1039.8 170.1,391.5 545.5,560.9 838.5,378.3 293.1,-182.7 392.7,-648.2 222.6,-1039.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14871.4,23338 c -48.3,0 -97.4,-7.6 -146.7,-22.9 -181.2,-56.5 -338.1,-210.6 -430.3,-423 -167.9,-386.4 -69.8,-847.1 218.5,-1026.8 120.2,-74.9 256.2,-92 393.3,-49.3 181.3,56.5 338.1,210.6 430.4,423 167.8,386.4 69.7,847.1 -218.6,1026.8 -77,48 -160.5,72.2 -246.6,72.2 z M 14761,21772.9 c -90.7,0 -179.4,25.2 -259,74.9 -296.7,184.9 -398.4,657.1 -226.6,1052.6 94.7,217.8 256.2,376.2 443.2,434.4 140.9,43.9 286.6,25.6 410.3,-51.5 296.7,-184.9 398.4,-657.1 226.6,-1052.6 -94.6,-217.9 -256.1,-376.2 -443.1,-434.4 -50.3,-15.7 -101.1,-23.4 -151.4,-23.4",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15208.6,22646.5 c -27.9,-147.2 -121.4,-248.5 -208.8,-226.3 -87.4,22.2 -135.6,159.6 -107.7,306.7 27.9,147.2 121.4,248.5 208.8,226.3 87.4,-22.2 135.6,-159.5 107.7,-306.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14571.5,22383.2 c -17.7,-72.8 -67.1,-121.7 -110.4,-109.1 -43.2,12.5 -63.8,81.8 -46,154.6 17.7,72.8 67.2,121.7 110.4,109.1 43.2,-12.5 63.8,-81.7 46,-154.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17441.1,9528.5 c 59,-40.2 101.5,-104.2 134.1,-170.4 32.4,-67 55.2,-139.7 69.4,-213.3 15.7,-74 22.4,-148.8 26.5,-224.3 0.5,-37.2 1.7,-75.2 1.3,-112.8 l -4.7,-112.7 c -3.4,-85.8 -75.8,-152.5 -161.6,-149 -85.9,3.5 -152.6,75.9 -149.1,161.7 0.8,19.3 5.1,37.6 12.2,54.4 l 2,4.5 38.8,90.6 c 12,30.4 22.6,61.2 34.1,92.4 19.8,62.1 38,125.7 48,190.3 11.5,64.9 15.4,130.8 9.8,197 -6.3,65.6 -20.7,133.8 -60.8,191.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16769.1,9476.2 c 39.9,-48.6 74,-103.3 104,-160.6 30,-57.5 55.7,-118.4 75.6,-182.3 20.2,-63.8 35.8,-130.6 44,-199.4 9.9,-69 10.4,-139.6 7.7,-211.6 v -1.3 c -3.2,-86.1 -75.5,-153.3 -161.5,-150.2 -86.1,3.2 -153.3,75.5 -150.2,161.5 0.8,21.8 6.4,43.1 15.2,61.6 23,48.2 45.6,98.9 60.3,153 16.5,53.8 26.9,110.4 33,168.6 6.4,58.3 7.1,118.2 2.6,178.7 -4.4,60.6 -13.5,121.8 -30.7,182",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19591.1,9528.5 c 59,-40.2 101.5,-104.2 134.1,-170.4 32.4,-67 55.2,-139.7 69.4,-213.3 15.7,-74 22.4,-148.8 26.5,-224.3 0.5,-37.2 1.7,-75.2 1.3,-112.8 l -4.7,-112.7 c -3.4,-85.8 -75.8,-152.5 -161.6,-149 -85.9,3.5 -152.6,75.9 -149.1,161.7 0.8,19.3 5.1,37.6 12.2,54.4 l 2,4.5 38.8,90.6 c 12,30.4 22.6,61.2 34.1,92.4 19.8,62.1 38,125.7 48,190.3 11.5,64.9 15.4,130.8 9.8,197 -6.3,65.6 -20.7,133.8 -60.8,191.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19019.1,9476.2 c 39.9,-48.6 74,-103.3 104,-160.6 30,-57.5 55.7,-118.4 75.6,-182.3 20.2,-63.8 35.8,-130.6 44,-199.4 9.9,-69 10.4,-139.6 7.7,-211.6 v -1.3 c -3.2,-86.1 -75.5,-153.3 -161.5,-150.2 -86.1,3.2 -153.3,75.5 -150.2,161.5 0.8,21.8 6.4,43.1 15.2,61.6 23,48.2 45.6,98.9 60.3,153 16.5,53.8 26.9,110.4 33,168.6 6.4,58.3 7.1,118.2 2.6,178.7 -4.4,60.6 -13.5,121.8 -30.7,182",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32650.8,12206.5 c -90.5,228.3 -210.3,390.3 -450.8,240.9 -390.7,-242.6 -35.6,-934.4 47.3,-1245.8 132,-496.3 239.8,-1044.9 -110.7,-1488.6 -586.4,-742.3 -1807,-500.8 -2413.3,85.5 -244.8,236.7 -447.9,575.6 -417.7,929.9 15.2,179 57.7,401.8 276.7,399.4 328,-3.4 197.1,-272 258.4,-457.6 166.2,-503 1145.3,-1020.8 1570.7,-546.8 274.8,306.3 -90.5,869.7 -200.9,1163.5 -247.1,657.3 -339.1,1359.3 157.2,1913.9 651.4,727.8 1673.8,622.9 2261.8,-135.3 180.6,-232.8 332.6,-497.8 221.5,-804.6 -191.7,-529.4 -960,-567.1 -1200.2,-54.4",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29579,11102.9 c -190.7,0 -232.6,-190.3 -248.5,-376.6 -36.4,-428 274.7,-778.9 410.2,-909.9 367.9,-355.8 959,-571.8 1470.1,-537.6 380.5,25.4 693.8,180.9 906.1,449.7 342.8,433.8 240.4,962.4 106.2,1466.6 -15.6,58.5 -40.6,129.7 -69.5,212.1 -119.5,340.3 -300,854.5 33.2,1061.4 94.2,58.5 175.7,75.2 249.4,50.9 119.5,-39.4 189.7,-182.5 237.6,-303.1 106.5,-226.8 334.6,-360.7 593.1,-348.5 260.4,11.8 475.2,165.6 560.6,401.6 108.7,300.2 -49.1,563.1 -217.8,780.7 -292.8,377.6 -708.1,602.8 -1139.6,618 -406.1,14.6 -791.5,-157.6 -1083.7,-484.1 -408.7,-456.5 -458.5,-1074.3 -152.5,-1888.4 21.7,-57.7 54.2,-127.8 88.6,-202 142.9,-307.9 338.5,-729.5 107.5,-987 -153.3,-170.8 -393.4,-232.3 -675.6,-173.3 -412.6,86.3 -833.2,413.3 -937.5,729 -19.2,58.2 -20.6,122.1 -22,183.9 -3.3,147.7 -5.6,254.3 -212.9,256.5 -1,0 -2.1,0.1 -3,0.1 m 1519.8,-1877.8 c -501.3,0 -1037,211.2 -1392.9,555.4 -297.2,287.3 -452.1,633.6 -425.2,950 16.8,196.9 65.9,422.4 298,422.4 1.3,0 2.6,-0.1 3.8,-0.1 255.6,-2.7 259.2,-163.5 262.4,-305.4 1.3,-58.1 2.7,-118.2 19.5,-169.3 99.3,-300.6 503.2,-612.7 900.2,-695.7 264.2,-55.3 487.3,0.7 628.2,157.7 209,232.9 21.4,637.3 -115.6,932.6 -34.9,75 -67.8,145.9 -90.1,205.4 -313.2,833.2 -260.2,1467.6 162,1939.4 302.3,337.7 702,515.2 1122.7,500.7 446.4,-15.8 875.5,-248.1 1177.4,-637.3 177.1,-228.4 342.3,-505.4 225.3,-828.5 -92.4,-255.3 -324.4,-421.7 -605.3,-434.5 -279.3,-12.7 -525.8,132.1 -641,378 l -0.6,1.4 c -65.2,164.2 -129,249 -207,274.7 -58.7,19.4 -126.6,4.4 -207.5,-45.8 -299.1,-185.8 -133.4,-657.8 -12.3,-1002.4 29.3,-83.4 54.6,-155.5 70.6,-215.8 131.5,-493.9 241.8,-1058.6 -115.2,-1510.5 -221.3,-280.2 -547.1,-442.2 -942,-468.6 -38.2,-2.6 -76.7,-3.8 -115.4,-3.8",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31102,9441.2 c -320.6,0 -665.2,100.3 -949.9,270.2 17.4,41.8 34.2,83.7 50.6,126 19.3,37.2 37.6,75.6 55,115.3 145,-84.5 303.5,-148.5 462.8,-181.8 82,-17.1 161.3,-25.6 237.2,-25.6 241.4,0 447.9,85.7 595.9,250.5 33.4,37.2 60.3,76.4 81.6,117 727.8,165.5 -124.4,939.8 -105.1,2060.7 4.4,249.5 115.5,489.3 314.8,639.4 124.3,93.7 243.4,128.1 358.9,128.1 160.8,0 314.6,-66.7 465.6,-133.5 151.1,-66.7 299.5,-133.5 449.6,-133.5 68.8,0 137.9,14 207.7,48.5 92.1,45.4 155.8,101.8 198,164.4 166.9,-230.9 207.8,-392.2 146.7,-560.9 -74.2,-205.1 -261.5,-285.5 -412,-292.3 -6.7,-0.3 -13.6,-0.4 -20.5,-0.4 -145.1,0 -323.8,64.6 -412.9,249.6 -61.3,153 -155.1,334 -337.7,394.2 -38.9,12.9 -78.7,19.3 -119.4,19.3 -86.5,0 -176.8,-29 -269.7,-86.7 -446.4,-277.2 -231,-890.8 -102.2,-1257.5 26.6,-75.9 51.8,-147.5 65.7,-199.8 123.3,-463.5 219.1,-947.4 -76,-1321 -230.5,-291.8 -555.2,-371.5 -786.9,-387 -32.3,-2.1 -64.9,-3.2 -97.8,-3.2",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29578.6,10936.8 c -19,0 -64,-6.1 -82.7,-224.6 -30.4,-357 241.7,-661.9 360.2,-776.4 336.1,-325.2 875.9,-522.4 1343.7,-491.4 231.7,15.5 556.4,95.2 786.9,387 295.1,373.6 199.3,857.5 76,1321 -13.9,52.3 -39.1,123.9 -65.7,199.8 -128.8,366.7 -344.2,980.3 102.2,1257.5 136.6,84.8 267.5,107.6 389.1,67.4 182.6,-60.2 276.4,-241.2 337.7,-394.2 93.3,-193.9 285.1,-255.5 433.4,-249.2 150.5,6.8 337.8,87.2 412,292.3 66.4,183.3 12.3,357.9 -192.9,622.5 -262.5,338.5 -632.2,540.3 -1014.3,553.8 -356.3,12.7 -695.4,-139.8 -954.1,-428.9 -368.6,-411.7 -406.9,-958.1 -120.8,-1719.3 19.5,-51.9 50.7,-119.2 83.8,-190.5 153.2,-330.1 384.6,-828.8 80.5,-1167.8 -194.5,-216.7 -490.2,-296.5 -833.1,-224.9 -472.2,98.8 -938.3,467.5 -1061.2,839.4 -27,81.8 -28.8,161.7 -30.3,232.3 -0.7,28.1 -1.6,67.8 -5.3,90.6 -8.9,1.7 -22.8,3.4 -43.4,3.6 h -1.7 m 1521.6,-1877.7 c -543.3,0 -1123.9,229 -1509.7,602.1 -333.2,322.1 -506.4,717.1 -475.2,1083.4 40.7,478.2 279.2,575.1 469,574.3 416.2,-4.5 423.8,-341.1 426.6,-467.8 1,-45.9 2,-93.4 11.2,-120.9 79.9,-242 442.8,-515.5 776.5,-585.3 144.3,-30.2 342.9,-36.3 470.6,106.1 135.9,151.4 -31.7,512.7 -142.6,751.8 -36.2,77.9 -70.3,151.6 -94.9,216.8 -337,896.7 -273.7,1586.4 193.7,2108.6 335.7,375.1 780.5,573 1252.3,555.9 495.7,-17.5 970.5,-273.2 1302.7,-701.5 192.8,-248.6 395.5,-585.5 250.2,-986.7 -115.7,-319.6 -404.6,-528 -753.9,-543.8 -348.2,-15.7 -654.7,165.6 -798.9,473.4 -1.6,3.5 -3.1,7 -4.5,10.6 -62.8,158.2 -102.7,177.3 -104.9,178.3 0.3,-0.3 -20.5,0.1 -67.7,-29.3 -185.9,-115.4 -39.9,-531.2 56.7,-806.3 29.2,-83.1 56.7,-161.5 74.4,-228.1 141.8,-532.7 259.2,-1144 -145.3,-1656.1 -251.3,-318 -618.2,-501.7 -1061.2,-531.4 -41.4,-2.7 -83.2,-4.1 -125.1,-4.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22322.1,12612.3 616.7,-3020 c -264,-103.5 -487.7,-344.9 -431.3,-881.2 h 611.3 575.2 635.9 l 735.9,3901.2 h -2743.7",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22530.2,8736.1 h 1779 l 726.4,3851.2 h -2682.9 l 614.8,-3010.6 -19.6,-7.7 c -316.7,-124.2 -457.1,-404.4 -417.7,-832.9 m 1820.4,-50 H 22485 l -2.3,22.4 c -48.2,457.4 95.6,759.8 427.5,899.2 l -618.7,3029.6 H 25096 l -5.6,-29.6 -739.8,-3921.6",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23739.2,8902.2 H 22937 c 52.4,353.4 363.1,434.6 588,522.8 l -576,1405.5 c 292.3,-151.1 621.9,-256.6 985.3,-314.1 18.9,-3 37.8,-5.8 56.6,-8.5 18.7,-113.2 38.4,-226.1 58.7,-338.9 29.2,-158.3 59.7,-316.3 92.1,-473.9 -48.6,-30.1 -95,-65.3 -137.5,-105.9 -83.7,-79.9 -148.2,-180.1 -189.8,-283.5 -42,-103.8 -62,-210.1 -71.3,-313 -2.4,-30.4 -3.6,-60.6 -3.9,-90.5",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24329.9,8520.1 h -1822.4 c -97.7,0 -179.7,73.8 -190,171 -61.5,585.2 183.1,869.7 405,1006.1 l -587.5,2876.9 c -21.1,103.4 45.5,204.3 148.9,225.4 103.5,21.2 204.3,-45.6 225.4,-149 l 616.7,-3020 c 18.5,-91 -31,-182.1 -117.5,-216 -137.4,-53.9 -309.8,-165.6 -318.6,-512.3 h 1481.6 l 500.6,2653.2 c 19.5,103.6 119.3,171.9 223.1,152.3 103.6,-19.6 171.8,-119.5 152.3,-223.1 l -529.9,-2808.9 c -17,-90.2 -95.9,-155.6 -187.7,-155.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26439.7,15841.6 c 0,0 298,-1247.9 1482.8,-1508.9 1184.8,-261 3019.8,-1308.6 2261.2,-4017.8 -758.6,-2709.1 -4826.4,411.8 -4826.4,411.8 0,0 -2557.5,-563.5 -3472.6,1517.2 -915,2080.6 1526.3,5570 4555,3597.7",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24686.2,13197.8 c -1149.2,0 -2115.6,647.2 -2395.1,1524.8 29.8,53.3 60.9,105.8 93.6,157.6 257.2,-374.7 607.9,-686.6 1028.9,-896.7 52.2,-184.4 183,-342.2 363.4,-424.5 89.9,-44.8 187.3,-66.7 284.1,-66.7 173.8,0 345.8,70.5 470.4,205.8 33.6,-1.2 67.2,-1.9 100.7,-1.9 692.8,0 1351.7,266.2 1849,722.9 175.7,49.8 339.6,113.9 490.7,191.8 16.8,-15 33.9,-29.9 51.4,-44.6 -338.6,-797.1 -1257.1,-1368.5 -2337.1,-1368.5",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27462.9,9886.1 c -48.8,15.2 -98.7,28.6 -149.6,39.9 -79.1,16.2 -161,28.8 -246.1,31.6 -32.3,69.7 -59.7,140.8 -77.7,213.9 -21.1,85.1 -37.6,172.7 -35.6,262.3 0.1,179 47.5,365.2 132.8,542.7 84.2,177.8 202.1,349.4 340.4,503.4 l 1.5,1.7 c 7.5,8.4 9.4,20.9 3.7,31.4 -0.1,0.1 -0.1,0.2 -0.2,0.3 0.9,0.2 1.7,0.3 2.4,0.3 65.2,0 -526.9,-797.3 28.4,-1627.5 m -860.4,259.1 c -131.9,74.6 -257,149.3 -372.3,220.7 19.6,141.6 36.3,283.7 48.7,426.7 7.1,78.1 13.4,156.5 18.4,235 225,-55.5 368.6,-102.8 459.3,-138.8 -70.2,-129.3 -122,-272.2 -145.8,-424.8 -16.7,-104.5 -19.3,-212.5 -8.3,-318.8 m -2672.5,759.3 c -889.4,157.5 -1515.2,626.5 -1860.7,1394.4 327.2,-394.5 877.4,-744.4 1797.8,-875.7 0.4,-4.1 0.8,-8.2 1.2,-12.3 17.6,-169.4 38,-338.3 61.7,-506.4",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27131,15785.6 c 353.5,1379.9 -478.5,2785 -1858.4,3138.5 -1379.8,353.5 -2785,-478.5 -3138.4,-1858.4 -353.5,-1379.8 478.5,-2785 1858.3,-3138.5 1379.9,-353.5 2785,478.6 3138.5,1858.4",
    style: {
      fill: "#ff002b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25357.1,10917.7 c 41.7,0 82.8,-13.6 116.4,-39.4 24.3,-18.6 2441,-1854.6 3773.6,-1410.5 371.9,124 618.1,418 752.7,898.7 277.3,990.6 217.6,1826.8 -177.5,2485.4 -541,901.4 -1537.6,1205.4 -1941,1294.2 -1123.3,247.5 -1515.4,1278.7 -1605.8,1573.8 -1145.5,718.5 -2331,679.5 -3261.6,-110.8 -980.1,-832.2 -1399.3,-2276.6 -954.3,-3288.3 350.1,-796.2 997.2,-1275.7 1923.1,-1425.3 711,-114.8 1327.6,16.5 1333.7,17.8 13.5,3 27.2,4.4 40.7,4.4 m 3437.2,-1898.6 c -1369.7,-0.1 -3111.1,1228.8 -3484.3,1504.4 -207.4,-35.4 -751.8,-105.8 -1375.7,-7.1 -1053.6,166.6 -1822.8,737.4 -2224.4,1650.6 -517.8,1177.2 -63.5,2782.2 1056.6,3733.3 1085,921.2 2461.8,958.1 3777.5,101.4 41,-26.7 70.1,-68 81.5,-115.5 12.2,-50 290,-1136.1 1338.1,-1367 451.6,-99.5 1568.9,-442 2186.3,-1470.8 451.3,-752.2 524.6,-1689.1 217.8,-2785 -169.1,-603.6 -505.5,-993.3 -1000.1,-1158.1 -179.4,-59.8 -372.4,-86.2 -573.3,-86.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27131.1,15785.6 h 0.4 -0.4 m -2498.2,3069.5 c -1082.8,0 -2072.7,-730.5 -2353.5,-1826.6 -332.3,-1297.5 452.8,-2623.6 1750.3,-2956 1297.5,-332.3 2623.6,452.8 2956,1750.3 332.4,1297.6 -452.7,2623.6 -1750.3,2956 -201.4,51.6 -403.5,76.3 -602.5,76.3 m -0.7,-5158.9 c -223.6,0 -450.6,27.7 -676.9,85.7 -1457.7,373.5 -2339.9,1863.3 -1966.5,3321.1 373.5,1457.7 1863.5,2339.8 3321.1,1966.4 1457.7,-373.4 2339.9,-1863.2 1966.5,-3321 -315.5,-1231.4 -1427.8,-2052.2 -2644.2,-2052.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24696.3,13997.1 c 0.1,0.5 0.2,1 0.3,1.5 30.1,117.5 27.7,238.3 -5.7,351.7 274.1,-40.7 536.2,-60.7 784.5,-60.7 114.6,0 226.2,4.3 334.7,12.8 -336.9,-187 -718.3,-294.8 -1113.8,-305.3",
    style: {
      fill: "#b20040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24678.2,13846.4 c -13.7,0 -27.4,0.1 -41.1,0.3 25.3,46.6 45.3,96.9 59.2,150.4 395.5,10.5 776.9,118.3 1113.8,305.3 140.3,10.9 275.6,28.9 405.2,53.8 -437.7,-325 -975.3,-509.9 -1537.1,-509.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24672.4,14004.8 c -87.6,-342.1 -435.9,-548.4 -778,-460.7 -342.1,87.6 -548.3,435.9 -460.7,778 87.6,342 436,548.3 778,460.7 342.1,-87.7 548.3,-436 460.7,-778",
    style: {
      fill: "#ffc200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24053.1,14777.9 c -273.8,0 -524.1,-184.8 -595.2,-462 -84.1,-328.2 114.5,-663.6 442.7,-747.6 328.4,-84 663.5,114.5 747.6,442.7 40.7,158.9 17.1,324.2 -66.5,465.4 -83.6,141.3 -217.2,241.5 -376.2,282.2 -50.9,13 -102,19.3 -152.4,19.3 m -0.2,-1278.9 c -54.4,0 -109.6,6.7 -164.7,20.8 -354.9,91 -569.6,453.6 -478.7,808.5 90.9,354.8 453.4,569.6 808.4,478.7 171.9,-44 316.4,-152.4 406.8,-305.1 90.4,-152.7 116,-331.4 71.9,-503.3 -76.8,-299.8 -347.5,-499.6 -643.7,-499.6",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24061.1,13492.3 c -96.8,0 -194.2,21.9 -284.1,66.7 35.2,-16 72.4,-29.2 111.2,-39.2 55.1,-14.1 110.3,-20.8 164.7,-20.8 180.2,0 350.9,73.9 474.3,199.3 1.4,-0.1 2.8,-0.1 4.3,-0.2 -124.6,-135.3 -296.6,-205.8 -470.4,-205.8",
    style: {
      fill: "#7a7ab5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24531.5,13698.1 c -1.5,0.1 -2.9,0.1 -4.3,0.2 24.1,24.5 46.5,51 66.7,79.3 -8.7,-13 -17.9,-25.8 -27.7,-38.4 -11.1,-14.3 -22.7,-28 -34.7,-41.1",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24053,13549 c -50.3,0 -101.5,6.2 -152.4,19.3 -231.9,59.4 -399.1,244.3 -447.6,463.5 95,-51.1 198.9,-76.1 302.4,-76.1 190.3,0 378.6,84.6 504.5,246.5 49.1,63.2 84.4,132.6 106.5,204.8 91,-18.3 180.8,-34.3 269.4,-48.3 37.5,-111.3 42.2,-231.2 12.4,-347.7 -71,-277.3 -321.2,-462 -595.2,-462",
    style: {
      fill: "#b28722",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24052.9,13499 c -54.4,0 -109.6,6.7 -164.7,20.8 -38.8,10 -76,23.2 -111.2,39.2 -37.4,18.7 -73.6,41.3 -108,68 -137.4,106.9 -219,258.9 -240.7,418.8 8.1,-4.9 16.4,-9.5 24.7,-14 48.5,-219.2 215.7,-404.1 447.6,-463.5 50.9,-13.1 102.1,-19.3 152.4,-19.3 274,0 524.2,184.7 595.2,462 29.8,116.5 25.1,236.4 -12.4,347.7 8.3,-1.3 16.7,-2.6 25,-3.9 69.4,-186.8 49.9,-402 -66.9,-577.2 -20.2,-28.3 -42.6,-54.8 -66.7,-79.3 -123.4,-125.4 -294.1,-199.3 -474.3,-199.3",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24053.1,14611.8 c -199.8,0 -382.5,-134.8 -434.3,-337.1 -61.4,-239.5 83.5,-484.2 323,-545.6 239.4,-61.3 484.2,83.5 545.6,323.1 29.7,116 12.5,236.6 -48.5,339.6 -61.1,103.1 -158.6,176.2 -274.6,206 -37.2,9.5 -74.5,14 -111.2,14 z m -0.2,-1278.9 c -68,0 -137.1,8.5 -205.9,26.1 -443.6,113.7 -712,567 -598.4,1010.5 113.7,443.5 566.7,712 1010.5,598.3 214.9,-55 395.5,-190.5 508.5,-381.3 113,-190.9 144.9,-414.3 89.9,-629.2 -96.1,-374.6 -434.5,-624.4 -804.6,-624.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23894.4,13469 c -6.1,0 -12.4,0.8 -18.6,2.4 -40.2,10.3 -64.3,51.1 -54.1,91.2 l 158.7,619.4 c 10.3,40.2 50.9,64.3 91.3,54.1 40.1,-10.3 64.3,-51.2 54,-91.3 l -158.7,-619.4 c -8.7,-33.8 -39.1,-56.4 -72.6,-56.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28420.6,19909.5 -2038.3,-205.7 c -284.6,193.7 -602,343.2 -948.4,431.9 -384.2,98.4 -772.9,114 -1150.9,64.2 l 1.2,0.7 -1782.8,1225.3 c -175.4,120.5 -416.7,40 -485.8,-161.3 -182.3,-531.3 -434.4,-1530.2 -199.5,-2522 l 2,1.2 c -241.7,-319.5 -420,-668.9 -511.6,-1026.4 -387.1,-1511.2 907.3,-2588.7 2725.4,-3054.5 1818,-465.7 3471.1,-143.3 3858.2,1368 110.3,430.4 105.6,911 1,1388.8 563.8,726.4 790.3,1607.1 877.9,2114.8 36.3,209.7 -136.6,396.4 -348.4,375",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28420.6,19909.5 -2038.3,-205.7 c -167.6,114.1 -346.8,212.3 -536.4,292.3 -514.4,-397.8 -845.9,-1020.6 -845.9,-1721.1 0,-1201.2 973.8,-2175 2175,-2175 266.4,0 521.5,48.1 757.4,135.7 63.2,375.6 47,780.6 -41.3,1184 563.8,726.4 790.3,1607.1 877.9,2114.8 36.3,209.7 -136.6,396.4 -348.4,375",
    style: {
      fill: "#d3670d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22778.7,20543 c -91.1,62.6 -216.5,20.7 -252.3,-83.8 -90.1,-262.4 -212.5,-744.6 -119.3,-1234.3 4.7,-25 9.6,-50.1 15.5,-75.2 l 1.1,0.1 c 0,0 38.4,59.7 118.7,146.2 174.9,188.4 549,504.2 1161.7,610.2 l 0.6,0.3 -926,636.5",
    style: {
      fill: "#ed2a84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22684.7,20547.4 c -15,0 -30,-2.4 -44.7,-7.3 -42.6,-14.1 -75.4,-46.5 -90,-89 -84.3,-245.6 -211.7,-730.9 -118.4,-1221.5 1.3,-6.9 2.6,-13.8 4,-20.7 20,26.1 49.3,61.9 88.5,104.2 165.7,178.5 527.6,489.3 1117,606.8 l -876.6,602.4 c -24,16.6 -51.7,25.1 -79.8,25.1 m -280.1,-1425.3 -6.3,21.8 c -6,25.5 -11,50.9 -15.8,76.3 -95.5,502 34.3,996.8 120.2,1247.1 19.8,57.4 64,101.3 121.6,120.3 57.4,18.9 118.8,10.2 168.6,-24.1 l 957.4,-658 -42,-24 c -609.7,-105.4 -980.7,-422.7 -1147.6,-602.5 -77.5,-83.6 -115.6,-142.1 -116,-142.7 l -6.2,-9.7 -33.9,-4.5",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22768.6,19439.1 c -1.3,9.3 -2.5,18.6 -3.5,27.9 38.2,30.3 80.1,61.1 125.7,91.7 -12.1,-10.2 -23.4,-19.9 -33.7,-29.2 -58.6,-52.9 -87.7,-90.4 -87.7,-90.4 h -0.8 m 828.6,420.4 c 20.9,4.7 42.1,9.1 63.5,13.3 l 7,-5.8 -0.4,-0.2 c -23.9,-1.9 -47.2,-4.4 -70.1,-7.3",
    style: {
      fill: "#c8c9e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22759.7,19526.2 c -22,318.3 83,615.7 155.9,779.1 14.6,32.7 42.4,54.4 73.6,62.6 l 431.4,-296.4 190.6,-157.8 c -375.7,-80.1 -656.8,-238.5 -851.5,-387.5",
    style: {
      fill: "#be2280",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22765.1,19467 c -0.8,7.7 -1.6,15.4 -2.4,23.1 -1.2,12.1 -2.2,24.1 -3,36.1 194.7,149 475.8,307.4 851.5,387.5 l 49.5,-40.9 c -21.4,-4.2 -42.6,-8.6 -63.5,-13.3 -342.6,-44.1 -576.8,-192.8 -706.4,-300.8 -45.6,-30.6 -87.5,-61.4 -125.7,-91.7 m 655.5,604.5 -431.4,296.4 c 9.3,2.5 19,3.8 28.7,3.8 24.7,0 49.7,-8.2 70.8,-25.6 l 331.9,-274.6",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22684.9,20472.4 c -8.8,0 -16.2,-1.8 -21.4,-3.5 -20.1,-6.6 -35.6,-22 -42.6,-42.2 -73.9,-215.5 -182.1,-620.5 -136,-1045.9 161.2,169.1 479,435.8 974.5,573 l -737.3,506.7 c -13.2,9.1 -26.3,11.9 -37.2,11.9 z m -261.3,-1422.6 c -46,0 -87.6,31.3 -98.4,77 -6.2,26.4 -11.3,52.9 -16.4,79.4 -98.7,519 34.7,1028.1 123,1285.4 27.4,79.9 89,140.8 169,167.2 79.8,26.3 165.3,14.2 234.6,-33.4 l 925.9,-636.4 c 27.8,-19.1 44.1,-50.9 43.4,-84.6 -0.8,-33.7 -18.4,-64.8 -47,-82.6 -11,-6.9 -23.8,-12 -36.6,-14.2 -587.9,-101.6 -944.9,-406.7 -1105.4,-579.6 -72.1,-77.8 -107.6,-132 -108,-132.5 -16,-24.5 -42,-41.1 -71,-44.8 -4.4,-0.6 -8.8,-0.9 -13.1,-0.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27889,19320 c 110,10.8 199.5,-86.4 180.4,-195.3 -48.1,-273.3 -174,-754.5 -492.3,-1138.1 -16.3,-19.7 -32.7,-39.3 -50,-58.4 l -0.9,0.7 c 0,0 -4.7,70.8 -33.2,185.3 -62,249.5 -236.8,706.8 -721.9,1095.8 l -0.4,0.6 1118.3,109.4",
    style: {
      fill: "#ed2a84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26832.8,19191.5 c 459.1,-387.8 625.6,-834.8 684.4,-1071.2 13.9,-55.9 22.3,-101.5 27.2,-133.9 4.5,5.4 9,10.7 13.5,16.1 318.9,384.4 441.9,870.8 486.9,1126.5 7.7,44.3 -5.3,88.6 -35.7,121.5 -30.4,32.7 -73.4,49.1 -117.7,44.6 l -1058.6,-103.6 m 697.6,-1296.8 -27.5,20.3 -1.7,12.2 c 0,0.7 -5,70.4 -32.5,181 -59.2,238.1 -230.5,695.2 -713.2,1082.3 l -5.4,6 -22.1,34.4 40.3,4.5 1118.2,109.5 c 60.2,5.8 118.2,-16.2 159.2,-60.5 41.2,-44.4 58.8,-104.2 48.3,-164.1 -45.8,-260.5 -171.4,-756.4 -497.7,-1149.7 -16.5,-19.9 -33.1,-39.8 -50.7,-59.2 l -15.2,-16.7",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27008.2,19133.3 c 367.5,-359.6 516.8,-746.7 576.1,-972.6 246.1,350.1 347.1,756.9 386.6,981.3 3.7,21 -2.4,41.9 -16.8,57.5 -8.4,9 -27.2,24 -55.4,21 l -890.5,-87.2 m 518.9,-1305.1 c -20.8,0 -41.6,6.4 -59.3,19.5 -23.7,17.5 -39.5,45.2 -41.4,74.6 0,0.4 -4.9,64.9 -30.5,167.8 -56.9,228.9 -221.8,668.6 -687.4,1041.8 -8.5,6.8 -15.8,15 -21.6,24.2 -18.8,29.3 -21.2,66.5 -5.9,97.8 15.1,31.4 45.3,52.8 80,56.2 l 1118.2,109.4 c 83.3,8 164.5,-22.4 221.6,-84.1 57.2,-61.8 81.7,-144.9 67.1,-228 -47.2,-267.9 -176.5,-778.1 -513.9,-1184.7 -17.2,-20.8 -34.5,-41.5 -52.9,-61.7 -19.6,-21.6 -46.7,-32.8 -74,-32.8",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21981.6,18803.5 c 20.3,-54.4 12.8,-116.7 -24,-165.3 -235.3,-311.2 -397.4,-635.6 -481.6,-964.2 -167.9,-655.8 -2.5,-1245.9 491.7,-1753.9 464.3,-477.3 1193.1,-853.4 2107.6,-1087.7 914.6,-234.3 1734.4,-254.8 2371,-59.6 677.6,207.8 1106.3,645.7 1274.3,1301.5 100.8,393.6 100.7,845.9 -0.4,1308.1 -11.1,50.6 0.8,103.7 32.7,144.7 550.4,709.1 764.9,1580.7 843.7,2037.2 7.9,45.9 -5.6,91.6 -37.2,125.5 -31.3,33.6 -75.4,50.2 -121.2,45.6 l -2038.3,-205.7 c -40.8,-4.1 -82,6.3 -116.1,29.5 -278.4,189.5 -579,326.4 -893.4,407 -347.3,88.9 -712.3,109.2 -1084.5,60.2 -51.9,-6.7 -101.6,9.7 -138.5,42.2 l -1765.1,1213 c -37.8,26.1 -84.6,32.8 -128.1,18.3 -44,-14.5 -77.9,-48.1 -93,-92.1 -168.7,-491.7 -417.6,-1454.9 -199.6,-2404.3 m 3493.8,-4513.9 c -453.2,-0.1 -951.9,66.7 -1486.9,203.8 -2135.1,547 -3227.7,1799 -2851.5,3267.5 89.5,349.5 254.6,692.3 491.1,1020.3 -215.5,1015.3 44.4,2022.6 222,2540.2 50.9,148.4 165.5,261.7 314.3,310.9 148.4,49 307.3,26.3 436.2,-62.2 l 1728.9,-1188.3 c 392.9,43.7 778.7,18 1147.8,-76.6 333.6,-85.4 652.9,-227 949.9,-420.9 l 1975.8,199.3 c 155.7,15.7 305.9,-40.8 412.4,-155.2 106.9,-114.6 152.8,-269 126.1,-423.7 -82,-474.9 -302.3,-1371.2 -862.9,-2127.3 95.9,-487.8 89.5,-966.8 -18.9,-1390 -282,-1100.4 -1228.9,-1697.7 -2584.3,-1697.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23849.8,16421.5 c -22.1,-52.9 -40.9,-108.7 -55.8,-166.9 -120.1,-468.7 53.9,-918.1 388.5,-1003.8 334.6,-85.7 703.1,224.7 823.2,693.3 14.9,58.3 25.3,116.3 31.4,173.3 l -1187.3,304.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24658.4,15663 c -31,-120.7 -201.4,-181.4 -380.7,-135.5 -179.3,45.9 -299.5,181.1 -268.6,301.9 31,120.7 201.4,181.4 380.7,135.5 179.3,-45.9 299.5,-181.1 268.6,-301.9",
    style: {
      fill: "#ed2a84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24269.9,15955.4 c -118.6,0 -215.5,-50.2 -236.6,-132.2 -12.8,-50.2 4.9,-105.6 50,-156.2 47.4,-53.4 118.7,-94.3 200.6,-115.3 165.6,-42.4 322.7,10.3 350.3,117.5 27.4,107.3 -85,229.1 -250.6,271.5 -38.9,9.9 -77.3,14.7 -113.7,14.7 z m 125.5,-468 c -39.9,0 -81.7,5.1 -123.9,15.9 -91.5,23.4 -171.6,69.7 -225.6,130.4 -56.4,63.5 -78.1,135.1 -61,201.9 34.3,133.9 218.9,202.8 411.1,153.5 192.3,-49.3 320.9,-198.3 286.6,-332.3 -26.8,-104.5 -145.1,-169.4 -287.2,-169.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25106.7,16801.9 c -53,-171.3 -418.9,-319.4 -590.2,-266.4 -171.3,53.1 -354.4,371.2 -301.4,542.5 53,171.3 322.1,130.9 493.4,77.8 171.3,-53 451.3,-182.6 398.2,-353.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24922.8,16885.2 c -9.5,-30.6 -78.7,-36.3 -154.7,-12.8 -76,23.6 -130,67.4 -120.5,98 9.5,30.6 78.8,36.4 154.8,12.8 76,-23.5 129.9,-67.4 120.4,-98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24715.2,16993.2 c -5.1,0 -10,-0.2 -14.8,-0.6 -26.8,-2.2 -44.5,-10.8 -48.4,-23.5 -4,-12.7 5.8,-29.8 26.7,-46.8 22.3,-18.1 54.5,-34.3 90.7,-45.5 72.3,-22.3 140.5,-17.8 149,9.8 v 0 c 8.6,27.7 -45.2,69.9 -117.4,92.3 -30.2,9.3 -60.1,14.3 -85.8,14.3 z m 140,-139.9 c -25.8,0 -56.4,4.8 -88.5,14.8 -37.3,11.5 -70.6,28.3 -93.8,47.1 -24.3,19.8 -34.9,39.9 -29.7,56.6 5.2,16.7 25.3,27.3 56.5,29.9 29.8,2.5 66.7,-2.5 104,-14.1 79.6,-24.6 133.8,-70.2 123.5,-103.7 v 0 c -6.2,-20 -33.8,-30.6 -72,-30.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25325.1,16334 c -34.4,-134.3 -244.2,-343.9 -480.9,-283.2 -236.8,60.6 -400.8,218.7 -366.4,353 -34.4,-134.3 -254.2,-194 -490.9,-133.4 -236.8,60.6 -319.9,345.3 -285.5,479.6",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25325.1,16334 c 0,-50.9 -18.5,-102 -43.5,-148.2 -25.3,-46.7 -60.1,-88.3 -100.5,-126 -41.3,-36.6 -90,-67.9 -145.9,-88.3 -55.9,-20.2 -118.7,-28.3 -180.9,-22.3 -32.9,3 -58.5,9 -85.6,14.5 -26.8,7 -53.4,14.7 -79.7,24.3 -53,18.8 -104.2,44.4 -153.5,77.7 -49,33.6 -95.5,76 -134.4,134.6 -19.3,29 -35,64.4 -44.7,104.2 -9.8,40.1 -9.6,86.3 0.4,130.3 15.2,67.3 82.2,109.6 149.5,94.3 67.3,-15.2 109.6,-82.2 94.3,-149.5 l -1.5,-6 -0.2,-0.8 c -12.3,-43.5 -34.4,-84.1 -62.3,-114.5 -27.6,-30.3 -58.5,-53.6 -89.3,-70 -62.2,-32.8 -123.4,-47.4 -182.6,-53.5 -59.2,-5.4 -116.5,-3.5 -171.9,5.6 -27.8,4.2 -54.8,10.4 -81.6,17 -26.4,8.2 -51.8,15.3 -82.1,28.5 -57.5,24.5 -108.7,62 -148,106.6 -39.3,44.8 -67,95.7 -85.6,147.6 -18.1,52.2 -27.9,105.8 -27.4,158.9 0.3,52.6 8.7,106.4 33.3,151 7.5,-99.5 50.8,-184.5 102.9,-252.9 52.8,-68.6 120.1,-113.1 188.5,-125.2 15.3,-3.7 37.6,-6.1 58.6,-8.5 21,-1.5 41.7,-3.7 62.4,-3.5 41.1,0 81.4,2.1 118.4,9.8 36.8,7.2 70.8,18.7 93.4,33.4 24.8,14.1 29.3,26.9 31.2,31.7 l 242.1,-62 c -0.9,-5.1 -2.8,-18.5 11.9,-43 12.8,-23.8 37.2,-50 65.8,-74.2 28.8,-24.5 63.1,-45.9 99.2,-65.7 18,-10 37.3,-18 56.4,-27 19.6,-7.9 40.3,-16.5 55.5,-20.7 65.9,-22.3 146.4,-15.5 225.8,19.3 79.2,34.3 156.9,89.3 211.6,172.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22507.2,17055.9 -594.9,152.4",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22489.4,16986.5 -577.1,221.8 612.7,-83 c 39.4,-5.4 67.1,-41.7 61.7,-81.1 -5.3,-39.5 -41.6,-67.2 -81.1,-61.8 -5.5,0.7 -11.2,2.2 -16.2,4.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22489.6,16704.1 -602.3,-119.7",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22503.5,16633.8 -616.2,-49.4 588.3,189.9 c 37.9,12.3 78.6,-8.6 90.8,-46.5 12.2,-37.9 -8.6,-78.5 -46.5,-90.7 -5.3,-1.7 -11,-2.8 -16.4,-3.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22625.7,16379.2 22134.3,16011",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22668.7,16321.8 -534.4,-310.8 448.5,425.5 c 28.9,27.4 74.5,26.2 101.9,-2.7 27.4,-28.9 26.2,-74.5 -2.6,-102 -4.1,-3.8 -8.8,-7.3 -13.4,-10",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26567.8,16015.7 594.9,-152.4 -594.9,152.4",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26585.6,16085 577.1,-221.7 -612.6,83 c -39.5,5.3 -67.2,41.7 -61.8,81.1 5.3,39.5 41.7,67.1 81.1,61.8 5.6,-0.8 11.2,-2.3 16.2,-4.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26414.1,15698.7 470.6,-394.5 -470.6,394.5",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26460.2,15753.6 424.5,-449.4 -516.6,339.6 c -33.3,21.9 -42.5,66.6 -20.6,99.9 21.8,33.2 66.6,42.5 99.8,20.6 4.7,-3.1 9.1,-6.9 12.9,-10.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26138.5,15479.3 253.9,-559.2 -253.9,559.2",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26203.7,15508.9 188.7,-588.8 -319.1,529.5 c -20.6,34.1 -9.6,78.5 24.5,99 34.2,20.6 78.5,9.6 99,-24.5 2.9,-4.8 5.3,-10.1 6.9,-15.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27427.1,11479.9 c -138.3,-154 -256.2,-325.6 -340.4,-503.4 -85.3,-177.5 -132.7,-363.7 -132.8,-542.7 -2,-89.6 14.5,-177.2 35.6,-262.3 21,-85.3 54.8,-167.8 94.3,-248.7 79.5,-162.2 189.5,-314.5 308.8,-469.6 l 1.4,-2 c 64.6,-84 48.8,-204.4 -35.2,-268.9 -74,-56.9 -176.5,-51.3 -243.9,8.4 -169.1,149.6 -311.1,340.2 -407.9,559.8 -12.6,27 -23.9,54.8 -33.3,83.8 -9.7,28.7 -20.7,56.7 -28.9,85.9 -14.2,59.5 -29.6,118.2 -36.7,179.3 -17,120.9 -16.4,245 2.7,364.5 37.5,240.3 144.6,457 283.4,633.8 141,176.5 308.1,321.9 500.8,426.3 13.4,7.2 30,2.2 37.3,-11.1 5.7,-10.5 3.8,-23 -3.7,-31.4 l -1.5,-1.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23855.7,12047.8 501.4,-2455.5 c -264,-103.5 -487.7,-344.9 -431.3,-881.2 h 611.2 575.3 635.9 l 529.8,2808.9 -2422.3,527.8",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23884.3,12053.7 c 79.9,-196.9 145.9,-396.5 209.5,-596.7 61.8,-200.6 119.6,-401.9 172,-604.4 53,-202.3 101.6,-405.6 148.1,-609.2 45.7,-203.8 89.2,-408.1 129.1,-613.1 l 0.4,-2.2 c 17.8,-91.3 -33.3,-179.9 -117,-212.4 -64.1,-24.9 -120,-58.1 -166.6,-98.9 -46.1,-41.3 -81.8,-92.4 -108.6,-152.5 -26.6,-60.1 -43.5,-129.3 -51,-203.1 -7.2,-74 -4.4,-152.4 1.7,-231.5 l -176.1,158.6 c 151.9,-1.5 303.7,-2.8 455.6,-0.9 l 455.6,3.2 911.2,10.9 -187.1,-155.1 c 41.7,234.6 85.3,468.7 130.9,702.5 l 71.1,350.2 75.4,349.4 c 50.4,232.9 106.2,464.7 173.7,694.4 66.7,229.8 140.9,458.2 237.2,682.5 6.5,15.1 24.1,22.2 39.2,15.6 11,-4.7 17.7,-15.2 18.1,-26.4 8,-244 -6.1,-483.7 -27.8,-722 -20.8,-238.5 -53.3,-474.7 -91.2,-710 l -57.1,-352.8 -61.3,-352.1 c -42.8,-234.3 -87.4,-468.3 -134,-701.9 l -0.9,-4.2 c -18,-90 -97.7,-152 -186.2,-150.9 l -911.2,11 -455.6,3.1 c -151.9,2 -303.7,0.6 -455.6,-0.8 -91.5,-0.9 -167.3,69.3 -176.1,158.6 -9.4,97.6 -14.8,197.1 -6.6,300.1 9.3,102.9 29.3,209.2 71.3,313 41.6,103.4 106.1,203.6 189.8,283.5 83.7,80.1 183,139 283.6,179.7 l -116.6,-214.5 c -43.6,204.2 -83.8,409.2 -121.6,614.6 -37,205.6 -72,411.6 -102.6,618.5 -31.2,206.8 -57,414.7 -78.7,623.4 -20,209.1 -37.6,418.7 -41.2,631.1 -0.3,16.4 12.8,29.9 29.2,30.2 12.5,0.2 23.5,-7.5 28,-18.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30145.3,10217.2 c 0,0 -427.6,-1332.7 -947.7,-1506.1 H 26297 c 0,0 -511.1,1969.7 2060.8,842.7 l 1787.5,663.4",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30274.3,10035.9 c -48.2,-143.7 -100.4,-275.9 -158.8,-411 -58.5,-133.9 -122.4,-266.1 -195.3,-395.7 -73.2,-129.5 -154.5,-256.9 -256.2,-377.5 -50.8,-60.2 -107.5,-118.5 -173.7,-172.2 -66.3,-53.3 -143.6,-102.8 -237.4,-134.4 -17.9,-6 -36.1,-8.9 -54,-9 h -1.3 l -2772.6,-0.9 h -1.6 c -81.7,0 -150.2,56.4 -168.8,132.3 -8.1,33 -12.6,55.8 -17.9,83.2 -4.9,26.2 -9.2,52.4 -12.9,78.6 -7.3,52.5 -12.3,105.2 -15.1,158.7 -5.1,106.8 -1.1,216.6 21.4,328.8 22.4,111.6 64.9,226.9 138.2,329.9 72.8,102.5 176.7,188 289.6,236.8 112.5,50.3 229.1,71.4 339,74.1 110.5,3.8 215.7,-11 316.4,-31.6 201.1,-44.8 385.6,-120.9 555.6,-220.8 28.3,-16.7 37.8,-53.2 21.1,-81.5 -12.3,-20.9 -35.4,-31.6 -58,-29 l -0.9,0.1 c -190.4,21.9 -375,47.8 -552.1,49.7 -175.6,4.5 -345.6,-19.1 -464.3,-83.8 -58.9,-33.3 -105.2,-74.4 -141.2,-128.3 -36.8,-52.9 -63.5,-119.2 -80.8,-193.4 -17.5,-74.1 -24.9,-155.8 -24,-239.1 0.4,-41.7 3,-83.9 7.6,-125.9 2.4,-21 5.1,-41.9 8.4,-62.6 2.9,-19.5 7.5,-43.4 10.7,-56.7 l -170.4,132.3 2772.6,-0.9 -55.4,-9 c 82.1,26.6 175.3,106.2 254.8,200.9 80.6,95.3 152.7,206.6 218.3,322.9 65.5,116.5 124.8,238.9 179.3,363.8 53.9,124.1 105.1,254.9 146.7,379 l 1.2,3.5 c 30.7,91.6 129.9,141 221.6,110.3 91.6,-30.8 141,-129.9 110.2,-221.6 v 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28357.8,9553.8 c -28.4,12.4 -56.7,24.6 -84.4,36.3 54.6,-4.5 106.6,-7.7 156.5,-9.6 l -72.1,-26.7 m 1126.2,418 c 188.9,211 368.4,509.8 631,903.6 -28,-164.8 -66.3,-334.4 -115.2,-508.9 -23.3,-83.2 -50,-160.9 -80,-233 L 29484,9971.8",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29919.8,10133.5 c 30,72.1 56.7,149.8 80,233 48.9,174.5 87.2,344.1 115.2,508.9 78.5,117.7 164.4,243.9 260.2,378.8 -20.1,-288.3 -74.4,-600.8 -169.1,-939.3 -6.4,-22.6 -13,-44.8 -19.8,-66.6 -7.1,3.5 -14.5,6.6 -22.2,9.2 -18.5,6.2 -37.3,9.1 -55.7,9.1 -73.1,0 -141.4,-46.2 -165.9,-119.4 l -1.2,-3.5 c -0.3,-0.8 -0.5,-1.7 -0.8,-2.5 l -20.7,-7.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29165.9,8886.1 26575,8887 c -3.8,37.7 -6,75.5 -6.3,112.9 -0.9,83.3 6.5,165 24,239.1 17.3,74.2 44,140.5 80.8,193.4 36,53.9 82.3,95 141.2,128.3 109.3,59.6 262.2,84.3 422.9,84.3 13.8,0 27.6,-0.1 41.4,-0.5 177.1,-1.9 361.7,-27.8 552.1,-49.7 l 0.9,-0.1 c 2.2,-0.3 4.4,-0.4 6.7,-0.4 20.4,0 40.2,10.5 51.3,29.4 2.2,3.7 4,7.6 5.3,11.6 138.2,-20.7 263.5,-35.8 378.1,-45.2 27.7,-11.7 56,-23.9 84.4,-36.3 l 72.1,26.7 c 35.8,-1.3 70.4,-2 103.9,-2 457,0 711.2,126.2 950.2,393.3 l 435.8,161.7 20.7,7.7 c -41.5,-123.3 -92.4,-253.3 -145.9,-376.5 -54.5,-124.9 -113.8,-247.3 -179.3,-363.8 -65.6,-116.3 -137.7,-227.6 -218.3,-322.9 -71.9,-85.7 -155.1,-159 -231.1,-191.9",
    style: {
      fill: "#afafd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29219.9,8711.1 h -2900.6 c 0,0 -240,925.4 437.3,1144.6 457,-100.2 829.7,-174.2 1138.7,-220.4 -1.3,-4 -3.1,-7.9 -5.3,-11.6 -11.1,-18.9 -30.9,-29.4 -51.3,-29.4 -2.3,0 -4.5,0.1 -6.7,0.4 l -0.9,0.1 c -190.4,21.9 -375,47.8 -552.1,49.7 -13.8,0.4 -27.6,0.5 -41.4,0.5 -160.7,0 -313.6,-24.7 -422.9,-84.3 -58.9,-33.3 -105.2,-74.4 -141.2,-128.3 -36.8,-52.9 -63.5,-119.2 -80.8,-193.4 -17.5,-74.1 -24.9,-155.8 -24,-239.1 0.3,-37.4 2.5,-75.2 6.3,-112.9 l 2590.9,-0.9 c 76,32.9 159.2,106.2 231.1,191.9 80.6,95.3 152.7,206.6 218.3,322.9 65.5,116.5 124.8,238.9 179.3,363.8 53.5,123.2 104.4,253.2 145.9,376.5 0.3,0.8 0.5,1.7 0.8,2.5 l 1.2,3.5 c 24.5,73.2 92.8,119.4 165.9,119.4 18.4,0 37.2,-2.9 55.7,-9.1 7.7,-2.6 15.1,-5.7 22.2,-9.2 -29.2,-93.6 -62.8,-179.5 -100,-258.8 -147.9,-388.5 -481.7,-1150.2 -866.4,-1278.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24217.8,8886.5 c -40.6,0 -81.1,0.1 -121.7,0.4 0.5,25.1 1.8,50 4.1,74.3 7.5,73.8 24.4,143 51,203.1 26.8,60.1 62.5,111.2 108.6,152.5 46.6,40.8 102.5,74 166.6,98.9 72.6,28.2 120.7,98.6 120.5,176.4 579.6,22.2 996.1,257.2 1295,572.2 -1.1,-5.3 -2.3,-10.6 -3.4,-15.8 l -75.4,-349.4 -71.1,-350.2 c -35.6,-182.9 -70.1,-366 -103.4,-549.3 l -751.6,-9 -455.6,-3.2 c -54.5,-0.7 -109.1,-0.9 -163.6,-0.9",
    style: {
      fill: "#a3a3cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25748.2,8711.1 h -1822.4 c -56.4,536.3 167.3,777.7 431.3,881.2 33.5,-1.3 66.4,-2 99,-2 30.7,0 61,0.6 90.8,1.8 0.2,-77.8 -47.9,-148.2 -120.5,-176.4 -64.1,-24.9 -120,-58.1 -166.6,-98.9 -46.1,-41.3 -81.8,-92.4 -108.6,-152.5 -26.6,-60.1 -43.5,-129.3 -51,-203.1 -2.3,-24.3 -3.6,-49.2 -4.1,-74.3 40.6,-0.3 81.1,-0.4 121.7,-0.4 54.5,0 109.1,0.2 163.6,0.9 l 455.6,3.2 751.6,9 c 33.3,183.3 67.8,366.4 103.4,549.3 l 71.1,350.2 75.4,349.4 c 1.1,5.2 2.3,10.5 3.4,15.8 88.9,93.6 167.4,194.3 236.7,298.7 l -330.4,-1751.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24708.7,9394.1 c -39.1,-45.7 -57.2,-102.4 -68.2,-157.6 -10.5,-55.8 -12.8,-112.1 -8.6,-168.2 2.9,-55.8 12.9,-111.4 24.4,-165.9 l 21,-81.4 25.2,-80.3 1.1,-3.6 c 21.9,-70 -17,-144.5 -87,-166.5 -69.9,-21.9 -144.5,17 -166.5,87 -4.9,15.7 -6.7,32.2 -5.8,47.7 l 5.8,96.2 c 2.9,32 7.2,64.2 10.8,95.8 10,63.7 22.1,126.8 41.8,188.3 18.4,61.3 44.1,121.1 77.4,175.3 33.4,53.4 75,104.1 128.6,133.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25182.2,9340.4 c -40.9,-105.8 -58.4,-216.6 -58.3,-322.7 0.1,-53.1 4.3,-105 14.3,-155.1 8.3,-50 24.1,-97.9 40.5,-143.4 26.4,-73.5 -11.8,-154.4 -85.2,-180.8 -73.5,-26.4 -154.4,11.7 -180.9,85.2 -6.6,18.6 -9.2,37.7 -8.1,56.2 l 0.2,1.9 c 4.2,65.2 11,128.8 26.3,190.1 13.6,61.4 33.9,120.1 57.9,175.8 48.2,111.2 113.3,211.4 193.3,292.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23089.3,9309.4 c -34.1,-40 -49.8,-89.6 -59.3,-137.9 -9.1,-48.7 -11,-98 -7.2,-147 2.7,-48.7 11.4,-97.3 21.6,-144.9 l 18.5,-71.2 22.2,-70.1 0.9,-3.1 c 19.4,-61.2 -14.5,-126.4 -75.6,-145.7 -61.2,-19.3 -126.4,14.6 -145.7,75.7 -4.4,13.7 -6,28.1 -5.2,41.7 l 4.9,84.1 c 2.4,28 6.1,56.1 9.2,83.7 8.7,55.8 19.2,110.9 36.3,164.7 15.9,53.6 38.2,105.9 67.2,153.3 29.1,46.7 65.4,91.2 112.2,116.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23539.5,9301 c -38,-98.9 -54.2,-202.6 -53.9,-301.8 0.3,-49.6 4.3,-98.2 13.7,-144.9 7.9,-46.8 22.7,-91.5 38.1,-134 24.8,-68.6 -10.7,-144.4 -79.3,-169.2 -68.6,-24.8 -144.4,10.7 -169.2,79.3 -6.3,17.4 -8.7,35.2 -7.7,52.5 l 0.1,1.8 c 3.8,60.9 10.1,120.4 24.3,177.8 12.6,57.3 31.4,112.3 53.8,164.4 44.8,104 105.5,197.9 180.1,274.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26011.6,14676.8 c 131.2,86.6 255.3,171.8 370.7,260 l 10.1,-16.7 -6.3,19.6 c 163,124.9 308.8,256.1 434.1,406.9 l 64.5,-42.4 -53.2,56.3 c 119.6,146.6 219.9,311.7 297.6,507.3 l 33.5,-4.5 h 0.1 -0.1 0.1 l -30.7,11.8 c 27.9,70.9 52.8,145.7 74.7,225.1 185.7,2.7 365.7,28.7 537.3,75.2 -7.1,-34.1 -14.9,-67.8 -23.4,-101.1 -168,-655.8 -596.7,-1093.7 -1274.3,-1301.5 -136.8,-41.9 -281.9,-73.9 -434.7,-96 m -384.7,5125.2 c -81.8,58.2 -165.1,114.1 -249.2,167.4 4.3,-1.1 8.5,-2.1 12.7,-3.2 103.3,-26.5 205.2,-59 305.2,-97.5 -23.4,-21.8 -46.3,-44 -68.7,-66.7",
    style: {
      fill: "#c8c9e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27206.7,16100.2 c 81.5,296.5 120,656.2 107.6,1108.1 -27.4,1002.8 -773.9,1944.4 -1687.4,2593.7 22.4,22.7 45.3,44.9 68.7,66.7 204.4,-78.7 401.3,-182.3 588.2,-309.5 29.2,-19.9 63.7,-30.4 98.6,-30.4 5.9,0 11.7,0.3 17.5,0.9 l 2038.3,205.7 c 5,0.5 10.1,0.7 15.1,0.7 40.2,0 78.2,-16.4 106.1,-46.3 31.6,-33.9 45.1,-79.6 37.2,-125.5 -78.8,-456.5 -293.3,-1328.1 -843.7,-2037.2 -31.9,-41 -43.8,-94.1 -32.7,-144.7 92.5,-423.1 100.5,-837.9 23.8,-1207 -171.6,-46.5 -351.6,-72.5 -537.3,-75.2 m 698.6,3320.6 c -8.7,0 -17.3,-0.4 -26.1,-1.3 L 26761,19310.1 c -34.7,-3.4 -64.9,-24.8 -80,-56.2 -15.3,-31.3 -12.9,-68.5 5.9,-97.8 5.8,-9.2 13.1,-17.4 21.6,-24.2 465.6,-373.2 630.5,-812.9 687.4,-1041.8 25.6,-102.9 30.5,-167.4 30.5,-167.8 1.9,-29.4 17.7,-57.1 41.4,-74.6 17.7,-13.1 38.5,-19.5 59.3,-19.5 27.3,0 54.4,11.2 74,32.8 18.4,20.2 35.7,40.9 52.9,61.7 337.4,406.6 466.7,916.8 513.9,1184.7 14.6,83.1 -9.9,166.2 -67.1,228 -51.2,55.2 -121.5,85.4 -195.5,85.4",
    style: {
      fill: "#a95221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27584.3,18160.7 c -21.1,80.4 -53.6,181.2 -103.3,293.9 151.3,270.9 198.1,568.1 212.1,744 0,0.6 0.1,1.2 0.1,1.8 l 205.5,20.1 c 2.5,0.2 5,0.4 7.3,0.4 24.2,0 40.4,-13.2 48.1,-21.4 14.4,-15.6 20.5,-36.5 16.8,-57.5 -39.5,-224.4 -140.5,-631.2 -386.6,-981.3",
    style: {
      fill: "#be2280",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27481,18454.6 c -89.9,204 -236,447.1 -472.8,678.7 l 685,67.1 c 0,-0.6 -0.1,-1.2 -0.1,-1.8 -14,-175.9 -60.8,-473.1 -212.1,-744",
    style: {
      fill: "#981b7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27527.1,17828.2 c -20.8,0 -41.6,6.4 -59.3,19.5 -23.7,17.5 -39.5,45.2 -41.4,74.6 0,0.4 -4.9,64.9 -30.5,167.8 -56.9,228.9 -221.8,668.6 -687.4,1041.8 -8.5,6.8 -15.8,15 -21.6,24.2 -18.8,29.3 -21.2,66.5 -5.9,97.8 15.1,31.4 45.3,52.8 80,56.2 l 1118.2,109.4 c 8.8,0.9 17.4,1.3 26.1,1.3 74,0 144.3,-30.2 195.5,-85.4 57.2,-61.8 81.7,-144.9 67.1,-228 -47.2,-267.9 -176.5,-778.1 -513.9,-1184.7 -17.2,-20.8 -34.5,-41.5 -52.9,-61.7 -19.6,-21.6 -46.7,-32.8 -74,-32.8 m -46.1,626.4 c 49.7,-112.7 82.2,-213.5 103.3,-293.9 246.1,350.1 347.1,756.9 386.6,981.3 3.7,21 -2.4,41.9 -16.8,57.5 -7.7,8.2 -23.9,21.4 -48.1,21.4 -2.3,0 -4.8,-0.2 -7.3,-0.4 l -205.5,-20.1 -685,-67.1 c 236.8,-231.6 382.9,-474.7 472.8,-678.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25697.8,14473.1 c 108.5,70.3 213.2,137.4 313.8,203.7 152.8,22.1 297.9,54.1 434.7,96 677.6,207.8 1106.3,645.7 1274.3,1301.5 8.5,33.3 16.3,67 23.4,101.1 76.7,369.1 68.7,783.9 -23.8,1207 -11.1,50.6 0.8,103.7 32.7,144.7 550.4,709.1 764.9,1580.7 843.7,2037.2 7.9,45.9 -5.6,91.6 -37.2,125.5 -27.9,29.9 -65.9,46.3 -106.1,46.3 -5,0 -10.1,-0.2 -15.1,-0.7 l -2038.3,-205.7 c -5.8,-0.6 -11.6,-0.9 -17.5,-0.9 -34.9,0 -69.4,10.5 -98.6,30.4 -186.9,127.2 -383.8,230.8 -588.2,309.5 -100,38.5 -201.9,71 -305.2,97.5 -4.2,1.1 -8.4,2.1 -12.7,3.2 -138.7,87.9 -279.8,168.9 -421.9,242.4 26.9,-6 432,-69.2 458.8,-76.1 346.4,-88.7 663.9,-238.2 948.5,-431.9 l 2038.3,205.7 c 11.1,1.1 22.1,1.7 33,1.7 196.3,0 349.7,-178 315.4,-376.7 -87.7,-507.7 -314.1,-1388.4 -878,-2114.8 104.7,-477.8 109.4,-958.4 -0.9,-1388.8 -261.1,-1019.2 -1098.3,-1497 -2173.1,-1557.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27162.7,15863.3 h -0.1 0.1",
    style: {
      fill: "#c8c9e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27162.7,15863.3 h -0.1 l -33.5,4.5 c 1,2.4 2,4.9 2.9,7.3 l 30.7,-11.8",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26884.7,15304.2 v 0",
    style: {
      fill: "#c8c9e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26884.7,15304.2 -64.5,42.4 c 3.8,4.6 7.6,9.2 11.3,13.9 l 53.2,-56.3",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26392.4,14920.1 v 0",
    style: {
      fill: "#c8c9e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26392.4,14920.1 -10.1,16.7 c 1.3,1 2.5,2 3.8,2.9 l 6.3,-19.6",
    style: {
      fill: "#000072",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22829.5,18027 c 83.4,106.2 206.5,170 341.2,197.4 67.8,13.2 139.4,13.4 211,4.1 70.9,-12.8 142.6,-33.9 206.4,-70.8 33.8,-17.1 59.3,-38 88.3,-57.6 27.6,-20.5 53.5,-45.6 79,-69.3 47.8,-52.7 92.5,-109.7 120.4,-177.2 57.8,-131.1 61.7,-290.2 -17.9,-402.1 -47.4,124.1 -112.2,207.2 -180.8,275.1 -34.1,34.2 -73,62.7 -110.8,91.6 -21.4,12.5 -38.9,28.3 -61.1,40.1 -20.9,12.1 -42.1,28.6 -62.1,36.9 l -29.4,16.8 c -10.3,4.6 -20.9,8.4 -31.1,13.5 -19.8,11.8 -42.6,16 -63.8,26.2 -44.6,14.2 -91.4,27.8 -142.2,37.7 -102.1,19.4 -214.7,29.4 -347.1,37.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26906,17119.5 c -119.8,56.8 -223.3,102.3 -322,134.7 -49.4,15.8 -96.9,26.6 -142.8,35.7 -23.5,1.2 -45.5,8.6 -68.5,7.8 -11.3,0.5 -22.5,2.3 -33.7,3.2 l -33.9,-0.5 c -21.6,2.4 -48,-1.9 -72.3,-2.3 -25,0.4 -48,-5 -72.8,-5.6 -47,-7.1 -94.9,-13.3 -141.2,-26.8 -92.9,-26.2 -189.8,-67.8 -291.2,-153.6 -15.7,136.5 64.6,273.9 178.5,360.9 57,45.6 123.7,73.9 191.1,97 33.7,8.4 68.5,17.9 102.6,22.5 34.8,3.1 67.3,9.1 105.1,7.8 73.6,1.5 146.6,-14.7 214.9,-37.7 67.2,-26.4 129.8,-61.1 182.8,-105.5 104.7,-89 181.7,-204.3 203.4,-337.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24477.8,16278.8 c -13.2,0 -26.8,2.1 -40.1,6.6 -65.3,22.1 -100.4,93.1 -78.3,158.5 l 117.2,346.2 c 22.1,65.3 93,100.4 158.5,78.3 65.4,-22.2 100.4,-93.1 78.3,-158.5 l -117.2,-346.2 c -17.6,-52.1 -66.2,-84.9 -118.4,-84.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27018.9,9418.3 c -36.9,-43 -53.9,-96.5 -64.3,-148.5 -9.9,-52.6 -12.1,-105.7 -8.1,-158.6 2.8,-52.6 12.1,-105 23,-156.4 l 19.8,-76.8 23.7,-75.7 1.1,-3.3 c 20.7,-66 -16,-136.3 -82,-157 -66,-20.7 -136.3,16 -157,82 -4.6,14.8 -6.3,30.3 -5.5,45 l 5.5,90.7 c 2.7,30.2 6.7,60.5 10.2,90.3 9.4,60.1 20.9,119.5 39.4,177.5 17.3,57.8 41.5,114.2 72.9,165.3 31.5,50.3 70.8,98.2 121.3,125.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27465.4,9367.8 c -38.6,-99.8 -55.1,-204.2 -55,-304.3 0.1,-50 4.1,-99 13.5,-146.2 7.8,-47.2 22.7,-92.3 38.1,-135.2 24.9,-69.3 -11,-145.6 -80.3,-170.5 -69.3,-24.9 -145.6,11.1 -170.5,80.3 -6.3,17.5 -8.7,35.5 -7.7,53 l 0.2,1.8 c 4,61.5 10.4,121.5 24.8,179.3 12.9,57.8 31.9,113.2 54.6,165.7 45.4,104.8 106.8,199.3 182.3,276.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34569.4,8653.7 c -1211.6,-80.1 -2423.2,-122.4 -3634.7,-154 -1211.6,-29.9 -2423.1,-46.5 -3634.7,-51.3 -1211.6,-2.5 -2423.1,0.9 -3634.7,9.1 l -1817.3,6.4 -908.7,2.1 -908.7,-2.3 -3634.7,-13.3 c -605.7,-3.8 -1211.5,-4.6 -1817.3,-4.8 -605.8,0.3 -1211.6,-3.3 -1817.3,0.2 -605.8,2.7 -1211.6,5.9 -1817.4,12.9 l -908.7,10 -908.64,15.7 c -1211.55,28.7 -2423.12,73.3 -3634.69,169.3 -20.7,1.7 -36.16,19.8 -34.52,40.5 1.49,18.7 16.4,33.1 34.52,34.5 1211.57,96 2423.14,140.6 3634.69,169.4 l 908.64,15.7 908.7,9.9 c 605.8,7.1 1211.6,10.2 1817.4,12.9 605.7,3.5 1211.5,0 1817.3,0.3 605.8,-0.2 1211.6,-1 1817.3,-4.9 l 3634.7,-13.2 908.7,-2.3 908.7,2.1 1817.3,6.4 c 1211.6,8.2 2423.1,11.6 3634.7,9 1211.6,-4.8 2423.1,-21.3 3634.7,-51.2 1211.5,-31.7 2423.1,-73.9 3634.7,-154.1 20.7,-1.3 36.4,-19.2 35,-40 -1.3,-19 -16.5,-33.8 -35,-35",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path416"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogAndCat);
export default __webpack_public_path__ + "static/media/dog-and-cat.ab87b6dc.svg";
export { ForwardRef as ReactComponent };